import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import "tippy.js/dist/tippy.css";
import _ from "lodash";
import Moment from "moment";
import MicroModal from "micromodal";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import { endOfDay, isWithinInterval, parse, startOfDay } from "date-fns";
import {
  Messages,
  MessageNotif,
  DirectboxReceive,
  CloseCircle,
} from "iconsax-reactjs";

//ACTIONS
import {
  refreshUsersAgents,
  ShowVisibleNextAtd,
  GetHistory,
  returnListCallQueue,
  DetailsAnotationsida,
  DetailsFileShared,
  CarregamentoCDR,
  DownloadFile,
  DetailsMarkstarida,
  SearchingHistoryData,
  RequestActiveCall,
  CarregamentoInteractions,
  SolicitarChamada,
  InterationNotifier,
  RequestActiveCallSocketVoz,
  ActionRefreshNoAnswer,
  callbackChange,
  filaChange,
  tratamentoChange,
  arrayChange,
  retornoChange,
  ShowInfoDisplay,
  InteracoesContactNumber,
  GetInteractionsModal,
  editInitialDateFilterQuarentine,
  editFinalDateFilterQuarentine,
  changeNextCallQueueTab,
  changeWaitingCallQueueTab,
  changeChatCallQueueTab,
  sendQueueAndStandby,
} from "../../actions";
import { RefreshNoAnswerCall } from "../../actions/websocket";
import { Tooltippy } from "../../actions/Tippy";

//COMPONENTS
import DeleteCallModal from "../../modals/DeleteCallModal";
import TransferClientModal from "../TransferClientModal";
import Drawer from "../../components/manager-section/Drawer/Drawer";
import ModalsDetails from "../../components/modals/NewModals/index";
import QueueItem from "../../components/queue-section-new/QueueItemNew";
import PdfDocument from "../../components/templates/PdfDocument";
import FieldContainer from "../../components/FieldContainer/FieldContainer";
import DatePicker from "../../components/DatePicker";
import QueueTab from "../../components/QueueTab";
import QuarentineZoneContent from "../../components/QuarentineZoneContent";
import Typography from "../../components/Typography";
import ChatsContent from "../../components/ChatsContent";

//ASSETS
import { ReactComponent as FilterIcon } from "../../build/images/filter.svg";
import { ReactComponent as Arrow } from "../../build/images/arrow-left.svg";
import { ReactComponent as Search } from "../../build/images/teams/search-normal.svg";
import { ReactComponent as FilterIconNew } from "../../build/images/teams/search-normal-new.svg";
import { ReactComponent as Anotacoes } from "../../build/images/popover-queue/edit-2.svg";
import { ReactComponent as ArquivosComp } from "../../build/images/popover-queue/direct-send.svg";
import { ReactComponent as MsgFavoritas } from "../../build/images/popover-queue/sms-star.svg";
import { ReactComponent as Mapa } from "../../build/images/popover-queue/picture-frame.svg";
import { ReactComponent as Interacoes } from "../../build/images/popover-queue/people.svg";
import { ReactComponent as AlterarExcluir } from "../../build/images/popover-queue/call-slash.svg";
import { ReactComponent as Transferir } from "../../build/images/popover-queue/redo.svg";
import { ReactComponent as IconMaximize } from "../../build/images/popover-queue/maximize-icon.svg";

//CSS
import "react-image-lightbox/style.css";
import "./queue-new-v2.css";

const { connection_platform } = require("../../services/api");
const { filtro_fila } = require("../../services/data");

let filtermediastorage = [];
let filterstatusstorage = [];
let filtersubservicestorage = [];

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
var statusIntervalCBack = "";
var checkCallBack = false;
var checkStatusAgente = "";

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
}

let statusQueue = [
  {
    id: "0",
    title: "CallBack",
  },
  {
    id: "1",
    title: "Em fila de espera",
  },
  {
    id: "2",
    title: "Em Tratamento",
  },
  {
    id: "5",
    title: "Retornando",
  },
];

MicroModal.init();

function checkCallBackAuto(queueid, time, qtdemax, statusagente, queue) {
  checkStatusAgente = statusagente;

  statusIntervalCBack = setTimeout(() => {
    let element = document.getElementById("clickqueue_" + queueid);
    if (typeof element != "undefined" && element != null) {
      element.click();
    }

    checkCallBack = false;
  }, time * 1000);
}

function getInfoQueue(queues, idqueue) {
  const queue = queues.find((queue) => queue.serviceinid === idqueue);
  return queue
    ? { id: queue.serviceinid, title: queue.name }
    : "Fila não encontrada";
}

function getInfoQueue2(queue) {
  return { id: queue.serviceinid, title: queue.name };
}

function parseData(dataString) {
  const [dia, mes, ano] = dataString.split("/");
  return new Date(ano, mes - 1, dia);
}

function createJSON(item) {
  var mensagem_tratada = item.replace(/¿/gi, "\n");
  mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
  let valor = 1;
  try {
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    var obj = JSON.parse(mensagem_tratada);
    mensagem_tratada = obj[1][0].mensagem_tratada;
  } catch (e) {
    mensagem_tratada = item;
  }
  return mensagem_tratada;
}

const mapDispatchToProps = (dispatch) => {
  return {
    actionChangeNextCallQueueTab: (isActive) => {
      dispatch(changeNextCallQueueTab(isActive));
    },
    actionChangeWaitingCallQueueTab: (isActive) => {
      dispatch(changeWaitingCallQueueTab(isActive));
    },
    actionChangeChatCallQueueTab: (isActive) => {
      dispatch(changeChatCallQueueTab(isActive));
    },
    actionEditInitialDateFilterQuarentine: (initialDate) => {
      dispatch(editInitialDateFilterQuarentine(initialDate));
    },
    actionEditFinalDateFilterQuarentine: (finalDate) => {
      dispatch(editFinalDateFilterQuarentine(finalDate));
    },
    testeeditar: (post, nome) => {
      dispatch(refreshUsersAgents(post, nome));
    },
    ReturningCallbackIn: (
      queueid,
      inforetorno,
      recvcount,
      cdrid,
      mediaid,
      srvin,
      caller,
      called,
      callback_count,
      status
    ) => {
      if (status != 2 || status != "2") {
        dispatch(
          returnListCallQueue(
            "",
            queueid,
            "2",
            parseInt(callback_count + 1),
            "você"
          )
        );
      }
    },
    SearchingHistory: (
      histstart,
      histend,
      idatendimento,
      telefone,
      idgroup
    ) => {
      dispatch(
        SearchingHistoryData(
          histstart,
          histend,
          idatendimento,
          telefone,
          idgroup
        )
      );
    },
    CarregamentoCDR: (queueid) => {
      CarregamentoCDR(queueid)(dispatch);
    },
    SolicitarChamada: (
      InfoUsers,
      scriptid,
      cdrid,
      mediaid,
      status,
      StatusAgent
    ) => {
      if (StatusAgent.allowCapture === false) {
        dispatch(InterationNotifier("Pausa não permite captura", "permission"));
      } else {
        dispatch(SolicitarChamada(InfoUsers, scriptid, cdrid, mediaid));
      }
    },
    CarregamentoInteractions: (cdr) => {
      CarregamentoInteractions(cdr)(dispatch);
    },
    ShowVisibleNextAtdIn: (post, temp) => {
      dispatch(ShowVisibleNextAtd(post, temp));
    },
    DetailsAnotationsida: (datainit, datafim, idcriticidade, telefone) => {
      dispatch(
        DetailsAnotationsida(datainit, datafim, idcriticidade, telefone)
      );
    },
    DetailsFileSharedIn: (datainit, datafim, formats, midias, telefone) => {
      dispatch(DetailsFileShared(datainit, datafim, formats, midias, telefone));
    },
    DetailsMarkstarida: (datainit, datafim, telefone) => {
      dispatch(DetailsMarkstarida(datainit, datafim, telefone));
    },
    DonwloadFileIn: (url, name) => {
      DownloadFile(url, name)(dispatch);
    },
    ClearHistory: (post) => {
      dispatch(GetHistory([]));
    },
    callbackChange: (post) => {
      dispatch(callbackChange(post));
    },
    filaChange: (post) => {
      dispatch(filaChange(post));
    },
    tratamentoChange: (post) => {
      dispatch(tratamentoChange(post));
    },
    retornoChange: (post) => {
      dispatch(retornoChange(post));
    },
    arrayChange: (post) => {
      dispatch(arrayChange(post));
    },
    ShowInfoDisplay: (post) => {
      dispatch(ShowInfoDisplay(post));
    },
    RequestActiveCall: (
      outband,
      infouser,
      trunk,
      mediaid,
      calledDigitado,
      addtech,
      scriptrunk,
      operator,
      returning,
      queueid,
      recvcount,
      cbackcount,
      idgrupo_transb,
      cdrold
    ) => {
      dispatch(
        RequestActiveCall(
          outband,
          infouser,
          trunk,
          mediaid,
          calledDigitado,
          addtech,
          scriptrunk,
          operator,
          returning,
          queueid,
          recvcount,
          cbackcount,
          idgrupo_transb,
          cdrold
        )
      );
    },
    InterationNotifier: (text, type) => {
      dispatch(InterationNotifier(text, type));
    },
    RequestActiveCallSocketVoz: (
      outband,
      infouser,
      trunk,
      mediaid,
      chamado,
      addtech,
      scriptrunk,
      operator,
      returning,
      queueid,
      recvcount,
      callback_count,
      tech,
      idgrupo_rota,
      idgrupo_transb,
      ipcurrent,
      cdrid,
      rotaencontrada
    ) => {
      dispatch(
        RequestActiveCallSocketVoz(
          outband,
          infouser,
          trunk,
          mediaid,
          chamado,
          addtech,
          scriptrunk,
          operator,
          returning,
          queueid,
          recvcount,
          callback_count,
          tech,
          idgrupo_rota,
          idgrupo_transb,
          ipcurrent,
          cdrid,
          rotaencontrada
        )
      );
    },
    PropsRefreshNoAnswer: (cdrid, queueid, infousers, queue) => {
      dispatch(ActionRefreshNoAnswer(queueid));
      RefreshNoAnswerCall(cdrid, queueid, infousers, queue);
    },
    InteracoesContactNumber: (number, datainit, datafim, mensagem, idgroup) => {
      dispatch(
        InteracoesContactNumber(number, datainit, datafim, mensagem, idgroup)
      );
    },
    GetInteractionsModal: (client, number) => {
      dispatch(GetInteractionsModal(client, number));
    },
    sendValuesQueueStandby: (queue, standby, msgsStandby) => {
      dispatch(sendQueueAndStandby(queue, standby, msgsStandby));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    listCallQueue: state.listcallqueue,
    InfoUsers: state.informationusers,
    PermissionRouter: state.routergroups,
    StatusAgent: state.status,
    OutBandService: state.outservices,
    DisplayNextAtd: state.displaynextatd,
    DetailsAnotations: state.detailsanotations,
    CriticidadesAnotacoes: state.criticalitys,
    IPCurrent: state.ipcurrent,
    DetailsMarkstar: state.detailsmarkstars,
    DetailsFileShared: state.detailsfileshared,
    History: state.history,
    CallBack: state.callback,
    AtdSimult: state.atdsimult,
    Filters: state.filters,
    InfoDisplay: state.infodisplay,
    callpark: state.callpark,
    ListQueuePermission: state.queuepermission,
    // qtdOfClientsInQuarentineZone: state.listQuarentineQueue.qtd,
    // qtdOfUnreadedMessagesInQuarentineZone:
    //   state.listQuarentineQueue.totalOfUnreadedMessages,
    listQuarentineQueue: state.listQuarentineQueue.list,
    defaultInitialDateQuarentine: state.dateOfFilterQuarentine.initial,
    defaultFinalDateQuarentine: state.dateOfFilterQuarentine.final,
    queueTabActiveNextCall: state.queueTabActive.isTabNextCallInfoActive,
    queueTabActiveWaiting: state.queueTabActive.isTabWaitingInfoActive,
    queueTabActiveChat: state.queueTabActive.isTabChatInfoActive,
    ContactId: state.atendimento,
  };
};

let initialDateLater = new Date();

class QueueNew extends Component {
  constructor(props) {
    super(props);
    var storageMedia = localStorage.getItem("clients_queue_media") || [];
    if (storageMedia.length !== 0) {
      storageMedia = storageMedia.split(",").map(Number);
    }
    var storageStatus = localStorage.getItem("clients_queue_status") || [];
    if (storageStatus.length !== 0) {
      storageStatus = storageStatus.split(",");
    }
    var storageSubservice =
      localStorage.getItem("clients_queue_subservice") || [];
    if (storageSubservice.length !== 0) {
      storageSubservice = storageSubservice.split(",").map(Number);
    }
    this.SearchHistoryQueue = this.SearchHistoryQueue.bind(this);

    initialDateLater.setDate(new Date().getDate() - 7);

    this.state = {
      buttonFilterQueue: false,
      buttonDetails: false,
      buttonDetailsIn: false,
      searchText: "",
      history: [],
      filterQueue: [],
      filterQuarentineQueue: "",
      keyQueue: [],
      visible: "",
      auxkeyQueue: [],
      typequeue: filtro_fila,
      callqueue: [],
      typesubservice: storageSubservice,
      typemedia: storageMedia,
      typestatus: storageStatus,
      expandQueue: [],
      DescAnotacoes: [],
      critSelec: "Todos",
      iconCrit: "",
      idCrit: "",
      buttonShowCriticits: false,
      detailsAnotations: [],
      totalAnotations: 0,
      detailsMarkstar: [],
      detailsFileShared: [],
      totalMarkstar: 0,
      totalFiles: 0,
      buttonLearnMore: false,
      expandLearn: [],
      optionsActionsFile: [],
      buttonShowOptionsAnot: false,
      buttonShowInsertAnot: false,
      SelecCritic: "Selecione",
      defaultValueFormat: "Todos",
      defaultValueMidias: "Todos",
      totalAnotations: 0,
      totalFiles: 0,
      totalMarkstar: 0,
      totalhistory: 0,
      nameCli: "Cliente",
      scrollEnd: 30,
      isOpen: false,
      cliente: "",
      midias: [],
      openDrawer: false,
      isViewStatus: false,
      isViewSubservices: false,
      isViewChannels: false,
      initialDate: initialDateLater,
      finalDate: new Date(),
      initialDateAfter: initialDateLater,
      finalDateAfter: new Date(),
      subservicesList: [],
      textSearchSubservice: "",
      textMediaCheck: "Marcar todos",
      textStatusCheck: "Marcar todos",
      textSubserviceCheck: "Marcar todos",
      tabChatsInfo: {
        id: "chats",
        title: "Conversas",
        qtdMessages: 0,
        isActive: this.props.queueTabActiveChat,
        icon: <Messages variant="Outline" />,
      },
      tabNextCallInfo: {
        id: "nextCall",
        title: "Próximos atendimentos",
        qtdMessages: 0,
        isActive: this.props.queueTabActiveNextCall,
        icon: <MessageNotif variant="Outline" />,
      },
      tabWaitingInfo: {
        id: "waiting",
        title: "Stand by",
        qtdMessages: 0,
        isActive: this.props.queueTabActiveWaiting,
        icon: <DirectboxReceive variant="Outline" />,
      },
      qtdOfClientsInTheQueue: 0,
      filteredListQuarentineQueue: this.props.listQuarentineQueue,
      qtdOfClientsInQuarentineZone: 0,
      qtdOfUnreadedMessagesInQuarentineZone: 0,
      qtdOfChatsInTheQueue: 0,
      filtermediastorageQuarentine: localStorage.getItem(
        "clients_queue-quarentine_media"
      )
        ? JSON.parse(localStorage.getItem("clients_queue-quarentine_media"))
        : [],
      textMediaCheckQuarentine: "Marcar todos",
      initialDateQuarentine: this.props.defaultInitialDateQuarentine,
      finalDateQuarentine: this.props.defaultFinalDateQuarentine,
    };

    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.DisplayDetails = this.DisplayDetails.bind(this);
    this.DisplayAnottations = this.DisplayAnottations.bind(this);
    this.change = this.change.bind(this);

    filterstatusstorage = storageStatus;
    filtermediastorage = storageMedia;
    filtersubservicestorage = storageSubservice;
  }

  updateFilteredList() {
    let { listQuarentineQueue } = this.props;
    let {
      filterQuarentineQueue: textToFilter,
      filtermediastorageQuarentine,
      initialDateQuarentine,
      finalDateQuarentine,
    } = this.state;

    let updatedFilteredListQuarentineQueue = listQuarentineQueue;
    const hasTextToFilter = !!textToFilter;
    if (hasTextToFilter) {
      updatedFilteredListQuarentineQueue = listQuarentineQueue.filter(
        (quarentineItem) => {
          return quarentineItem.contactName
            .toLowerCase()
            .includes(textToFilter.toLowerCase());
        }
      );
    }

    const hasFiltermediastorageQuarentine =
      !!filtermediastorageQuarentine &&
      Array.isArray(filtermediastorageQuarentine) &&
      filtermediastorageQuarentine.length > 0;
    if (hasFiltermediastorageQuarentine) {
      updatedFilteredListQuarentineQueue =
        updatedFilteredListQuarentineQueue.filter((quarentineItem) => {
          return filtermediastorageQuarentine.includes(
            parseInt(quarentineItem.midiaId)
          );
        });
    }

    const hasFinalAndInitialDate =
      !!initialDateQuarentine && !!finalDateQuarentine;
    if (hasFinalAndInitialDate) {
      updatedFilteredListQuarentineQueue =
        updatedFilteredListQuarentineQueue.filter((quarentineItem) => {
          const hasDateTime = !!quarentineItem.dateTime;
          if (!hasDateTime) {
            return true;
          }
          const dateOfStandBy = parse(
            quarentineItem.dateTime,
            "dd/MM/yyyy HH:mm:ss",
            new Date()
          );
          return isWithinInterval(dateOfStandBy, {
            start: startOfDay(initialDateQuarentine),
            end: endOfDay(finalDateQuarentine),
          });
        });
    }

    const updatedQtdOfUnreadedMessagesInQuarentineZone =
      updatedFilteredListQuarentineQueue.reduce((accumulator, currentValue) => {
        const unreadMessages = currentValue.unreadMessages
          ? currentValue.unreadMessages
          : 0;
        return accumulator + unreadMessages;
      }, 0);
    this.setState({
      filteredListQuarentineQueue: updatedFilteredListQuarentineQueue,
      qtdOfClientsInQuarentineZone: updatedFilteredListQuarentineQueue.length,
      qtdOfUnreadedMessagesInQuarentineZone:
        updatedQtdOfUnreadedMessagesInQuarentineZone,
    });
  }

  //VIRA STATE
  componentDidMount() {
    this.setState({
      RetractExpand: "Expandir todos",
      expandcollapse: "expand",
      queueid: -1,
      filter: "",
      unfold: "unfold_more",
    });
    this.updateFilteredList();
  }
  //VIRA STATE
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.listQuarentineQueue !== this.props.listQuarentineQueue ||
      prevState.filterQuarentineQueue !== this.state.filterQuarentineQueue ||
      prevState.filtermediastorageQuarentine !==
        this.state.filtermediastorageQuarentine ||
      prevState.initialDateQuarentine !== this.state.initialDateQuarentine ||
      prevState.finalDateQuarentine !== this.state.finalDateQuarentine
    ) {
      this.updateFilteredList();
    }
  }

  handleKeyUp(inf) {
    var elems = document.getElementsByTagName("mark");
    var tam = elems.length;

    if (tam >= this.state.arrowterm + 1) {
      elems[this.state.arrowterm].scrollIntoView(false);
      if (inf == "less") {
        if (this.state.arrowterm != 0) {
          this.state.arrowterm = this.state.arrowterm - 1;
        }
      } else {
        this.state.arrowterm = this.state.arrowterm + 1;
      }
    } else {
      if (elems[this.state.arrowterm]) {
        this.state.arrowterm = 0;
        elems[this.state.arrowterm].scrollIntoView(false);
      }
    }
  }

  SearchHistoryQueue(telefone) {
    let now = Moment().subtract(7, "days");
    const histstart = now.format("YYYY-MM-DD") + "T00:00";
    const histend = Moment().format("YYYY-MM-DD") + "T23:59";
    let idgroup = this.props.InfoUsers.idgroup;
    this.props.SearchingHistory(histstart, histend, 33, telefone, idgroup);
    this.setState({ datapdfend: histend, datapdfinit: histend });
  }

  DisplayHistoric(telefone, cdrid) {
    let now = Moment().subtract(7, "days");
    const histstart = now.format("YYYY-MM-DD") + "T00:00";
    const histend = Moment().format("YYYY-MM-DD") + "T23:59";
    let idgroup = this.props.InfoUsers.idgroup;
    this.props.InteracoesContactNumber(
      telefone.substr(2),
      histstart,
      histend,
      "",
      idgroup
    );
  }

  DisplayFilterQueue(e) {
    // e.preventDefault();
    this.setState({ buttonFilterQueue: !this.state.buttonFilterQueue });
  }

  DisplayDetails(e) {
    e.preventDefault();
    this.setState({ buttonDetails: !this.state.buttonDetails });
    let newState = this.state.buttonDetails
      ? {
          RetractExpand: "Expandir todos",
          expandcollapse: "expand",
          unfold: "unfold_more",
        }
      : {
          RetractExpand: "Retrair Todos",
          expandcollapse: "collapse",
          unfold: "unfold_less",
          expandQueue: [],
        };
    this.setState(newState);
  }

  DisplayDetailsIn(event, idqueue) {
    event.preventDefault();
    this.setState({
      buttonDetailsIn: !this.state.buttonDetailsIn,
      queueid: idqueue,
    });
  }

  DisplayAnottations(event, idqueue) {
    event.preventDefault();
    this.setState({ queueid: idqueue });
  }

  change(e) {}

  get_filesize(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open("HEAD", url, true);

    xhr.onreadystatechange = function () {
      if (this.readyState == this.DONE) {
        callback = callback(parseInt(xhr.getResponseHeader("Content-Length")));
      }
    };
    xhr.send();
  }

  changeQueue(e) {
    const isQuarentineZone =
      this.state.tabWaitingInfo.isActive || this.state.tabChatsInfo.isActive;
    //se for a fila normal vai setar o valor de filterQueue
    if (!isQuarentineZone) {
      const newState = { filterQueue: e.target.value };

      if (e.target.value !== "") {
        newState.keyQueue = [];
      } else {
        newState.keyQueue = this.state.auxkeyQueue;
      }

      this.setState(newState);
    } else {
      this.setState({ filterQuarentineQueue: e.target.value });
    }
  }

  clearChangeQueue(value) {
    const isQuarentineZone =
      this.state.tabWaitingInfo.isActive || this.state.tabChatsInfo.isActive;
    //se for a fila normal vai setar o valor de filterQueue
    if (!isQuarentineZone) {
      const newState = { filterQueue: value };

      if (value !== "") {
        newState.keyQueue = [];
      } else {
        newState.keyQueue = this.state.auxkeyQueue;
      }

      this.setState(newState);
    } else {
      this.setState({ filterQuarentineQueue: value });
    }
  }

  handleCheckAll(e, type) {
    if (type === "status") {
      let newStatusStorage = [];
      statusQueue.forEach((datum) => {
        if (e.target.checked) {
          document.getElementById(`checkbox-status-${datum.id}`).checked = true;
          newStatusStorage.push(datum.id);
          this.setState({ textStatusCheck: "Desmarcar todos" });
        } else {
          document.getElementById(
            `checkbox-status-${datum.id}`
          ).checked = false;
          // filterstatusstorage = [];
          this.setState({ textStatusCheck: "Marcar todos" });
        }
      });
      filterstatusstorage = newStatusStorage;
    } else if (type === "media") {
      let newMediaStorage = [];
      this.state.midias.forEach((datum) => {
        if (e.target.checked) {
          this.setState({ textMediaCheck: "Desmarcar todos" });
          // document.getElementById(`checkbox-media-all`).checked = false;
          document.getElementById(`checkbox-media-${datum.id}`).checked = true;
          newMediaStorage.push(datum.id);
        } else {
          // document.getElementById(`checkbox-media-all`).checked = false;
          this.setState({ textMediaCheck: "Marcar todos" });
          document.getElementById(`checkbox-media-${datum.id}`).checked = false;
          // filtermediastorage = [];
        }
      });
      filtermediastorage = newMediaStorage;
    } else if (type === "subservice") {
      let newSubserviceStorage = [];
      this.state.subservicesList.forEach((datum) => {
        if (e.target.checked) {
          this.setState({ textSubserviceCheck: "Desmarcar todos" });
          document.getElementById(
            `checkbox-subservice-${datum.id}`
          ).checked = true;
          newSubserviceStorage.push(datum.id);
        } else {
          this.setState({ textSubserviceCheck: "Marcar todos" });
          document.getElementById(
            `checkbox-subservice-${datum.id}`
          ).checked = false;
          // filtersubservicestorage = [];
        }
      });
      filtersubservicestorage = newSubserviceStorage;
    }
  }

  handleCheckAllQuarentine(e, type) {
    if (type === "media") {
      let newMediaStorage = [];
      this.state.midias.forEach((datum) => {
        if (e.target.checked) {
          this.setState({ textMediaCheckQuarentine: "Desmarcar todos" });
          // document.getElementById(`checkbox-media-all`).checked = false;
          document.getElementById(
            `checkbox-media-quarentine-${datum.id}`
          ).checked = true;
          newMediaStorage.push(datum.id);
        } else {
          // document.getElementById(`checkbox-media-all`).checked = false;
          this.setState({ textMediaCheckQuarentine: "Marcar todos" });
          document.getElementById(
            `checkbox-media-quarentine-${datum.id}`
          ).checked = false;
          // filtermediastorage = [];
        }
      });
      this.setState({ filtermediastorageQuarentine: newMediaStorage });
      localStorage.setItem(
        "clients_queue-quarentine_media",
        JSON.stringify(newMediaStorage)
      );
    }
  }

  getFilterQueue(e, idqueue) {
    let filtro = this.state.typequeue;
    if (e.target.checked) {
      this.setState({
        typequeue: this.state.typequeue.concat([idqueue]),
      });
      localStorage.setItem("filtro_fila", filtro.concat([idqueue]));
      this.saveTostorage(idqueue, true);
      // this.props.arrayChange(filtro.concat([idqueue]));
    } else {
      this.setState({
        typequeue: this.state.typequeue.filter(function (val) {
          return val != idqueue;
        }),
      });
      localStorage.setItem(
        "filtro_fila",
        filtro.filter(function (val) {
          return val != idqueue;
        })
      );
      this.saveTostorage(idqueue, false);
      // this.props.arrayChange(
      //   filtro.filter(function (val) {
      //     return val != idqueue;
      //   })
      // );
    }
  }

  saveTostorage(idqueue, value) {
    switch (idqueue) {
      case "0":
        localStorage.setItem("fila_checkbox_callback", value);
        this.props.callbackChange(value);
        break;
      case "1":
        localStorage.setItem("fila_checkbox_espera", value);
        this.props.filaChange(value);
        break;
      case "2":
        localStorage.setItem("fila_checkbox_em_tratamento", value);
        this.props.tratamentoChange(value);
        break;
      case "5":
        localStorage.setItem("fila_checkbox_retorno", value);
        this.props.retornoChange(value);
        break;
    }
  }

  applyAllFields() {
    if (this.state.tabNextCallInfo.isActive) {
      this.applyFilterMedia();
      this.applyFilterStatus();
      this.applyFilterSubservice();
      this.setState({
        isViewStatus: false,
        isViewChannels: false,
        isViewSubservices: false,
        initialDateAfter: this.state.initialDate,
        finalDateAfter: this.state.finalDate,
      });
      this.setVisibleDrawer(this);
    } else {
      this.setState({
        isViewStatus: false,
        isViewChannels: false,
        isViewSubservices: false,
      });
      this.setVisibleDrawer(this);
    }
  }

  applyFilterSubservice() {
    this.setState({
      typesubservice: filtersubservicestorage,
    });
    localStorage.setItem("clients_queue_subservice", filtersubservicestorage);
  }

  applyFilterStatus() {
    this.setState({
      typestatus: filterstatusstorage,
    });
    this.props.arrayChange(filterstatusstorage);
    localStorage.setItem("clients_queue_status", filterstatusstorage);
  }

  applyFilterMedia() {
    this.setState({
      typemedia: filtermediastorage,
    });
    localStorage.setItem("clients_queue_media", filtermediastorage);
  }

  clearclearAllFieldsQuarentine() {
    this.state.midias.forEach((datum) => {
      document.getElementById(
        `checkbox-media-quarentine-${datum.id}`
      ).checked = false;
    });
    //ttk
    this.setState({
      isViewStatus: false,
      isViewChannels: false,
      isViewSubservices: false,
      textMediaCheckQuarentine: "Marcar todos",
      filtermediastorageQuarentine: [],
      initialDateQuarentine: new Date().setDate(new Date().getDate() - 30),
      finalDateQuarentine: new Date(),
    });
    localStorage.setItem("clients_queue-quarentine_media", JSON.stringify([]));
    this.setVisibleDrawer(this);
  }

  clearAllFields() {
    statusQueue.forEach((datum) => {
      document.getElementById(`checkbox-status-${datum.id}`).checked = false;
    });
    this.state.midias.forEach((datum) => {
      document.getElementById(`checkbox-media-${datum.id}`).checked = false;
    });
    this.state.subservicesList.forEach((datum) => {
      document.getElementById(
        `checkbox-subservice-${datum.id}`
      ).checked = false;
    });
    filtersubservicestorage = [];
    filtermediastorage = [];
    filterstatusstorage = [];
    this.applyFilterMedia();
    this.applyFilterStatus();
    this.applyFilterSubservice();
    this.setState({
      isViewStatus: false,
      isViewChannels: false,
      isViewSubservices: false,
      textMediaCheck: "Marcar todos",
      textSubserviceCheck: "Marcar todos",
      textStatusCheck: "Marcar todos",
      initialDateAfter: initialDateLater,
      finalDateAfter: new Date(),
      initialDate: initialDateLater,
      finalDate: new Date(),
    });
    document.getElementById(`checkbox-status-all`).checked = false;
    document.getElementById(`checkbox-media-all`).checked = false;
    document.getElementById(`checkbox-subservice-all`).checked = false;
    this.setVisibleDrawer(this);
  }

  getFilterMedia(e, idmedia) {
    if (e.target.checked) {
      filtermediastorage = filtermediastorage.concat([idmedia]);
      if (filtermediastorage.length === this.state.midias.length) {
        this.setState({ textMediaCheck: "Desmarcar todos" });
        document.getElementById(`checkbox-media-all`).checked = true;
      }
    } else {
      filtermediastorage = filtermediastorage.filter(function (val) {
        return val != idmedia;
      });
      document.getElementById(`checkbox-media-all`).checked = false;
      this.setState({ textMediaCheck: "Marcar todos" });
    }
  }

  getFilterMediaQuarentine(e, idmedia) {
    let updatedFiltermediastorageQuarentine =
      this.state.filtermediastorageQuarentine;
    if (e.target.checked) {
      updatedFiltermediastorageQuarentine =
        updatedFiltermediastorageQuarentine.concat([idmedia]);
      if (
        this.state.filtermediastorageQuarentine.length ===
        this.state.midias.length
      ) {
        this.setState({ textMediaCheckQuarentine: "Desmarcar todos" });
        document.getElementById(`checkbox-media-all-quarentine`).checked = true;
      }
    } else {
      updatedFiltermediastorageQuarentine =
        updatedFiltermediastorageQuarentine.filter(function (val) {
          return val != idmedia;
        });
      document.getElementById(`checkbox-media-all-quarentine`).checked = false;
      this.setState({ textMediaCheckQuarentine: "Marcar todos" });
    }
    this.setState({
      filtermediastorageQuarentine: updatedFiltermediastorageQuarentine,
    });
    localStorage.setItem(
      "clients_queue-quarentine_media",
      JSON.stringify(updatedFiltermediastorageQuarentine)
    );
  }

  getFilterStatus(e, idstatus) {
    if (e.target.checked) {
      filterstatusstorage = filterstatusstorage.concat([idstatus]);
      if (filterstatusstorage.length === statusQueue.length) {
        this.setState({ textStatusCheck: "Desmarcar todos" });
        document.getElementById(`checkbox-status-all`).checked = true;
      }
    } else {
      filterstatusstorage = filterstatusstorage.filter(function (val) {
        return val != idstatus;
      });
      document.getElementById(`checkbox-status-all`).checked = false;
      this.setState({ textStatusCheck: "Marcar todos" });
    }
  }

  getFilterSubservice(e, serviceinid) {
    if (e.target.checked) {
      filtersubservicestorage = filtersubservicestorage.concat([serviceinid]);
      if (
        filtersubservicestorage.length === this.state.subservicesList.length
      ) {
        this.setState({ textSubserviceCheck: "Desmarcar todos" });
        document.getElementById(`checkbox-subservice-all`).checked = true;
      }
    } else {
      filtersubservicestorage = filtersubservicestorage.filter(function (val) {
        return val != serviceinid;
      });
      document.getElementById(`checkbox-subservice-all`).checked = false;
      this.setState({ textSubserviceCheck: "Marcar todos" });
    }
  }

  DisplayDetailsIn(event, idqueue) {
    event.preventDefault();
    this.setState({
      buttonDetailsIn: !this.state.buttonDetailsIn,
      queueid: idqueue,
    });
  }

  checkExpandQueue = (e, idqueue) => {
    var checkClick =
      this.state.expandQueue.indexOf(idqueue) != -1 ? true : false;

    if (!checkClick) {
      this.setState({
        expandQueue: this.state.expandQueue.concat([idqueue]),
      });
    } else {
      this.setState({
        expandQueue: this.state.expandQueue.filter(function (val) {
          return val != idqueue;
        }),
      });
    }
  };

  buttonSearchAnotation(e, telefone) {
    var erro = 0;
    let now = Moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = Moment().format("YYYY-MM-DD");
    const idcriticidade = this.state.idCrit;

    let comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      this.props.DetailsAnotationsida(
        datainit,
        datafim,
        idcriticidade,
        telefone
      );
    }
  }

  buttonSearchFileCompart(e, telefone) {
    var erro = 0;
    let now = Moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = Moment().format("YYYY-MM-DD");
    const formats =
      "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28";
    const midias = "2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18";

    var comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (formats == "") var erro = 1;

    if (midias == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      this.props.DetailsFileSharedIn(
        datainit,
        datafim,
        formats,
        midias,
        telefone
      );
    }
  }

  // SolicitarChamadaAtiva = (
  //   e,
  //   permrouter,
  //   mediaid,
  //   status,
  //   infouser,
  //   chamado,
  //   outband,
  //   queue,
  //   AtdSimult,
  //   ipcurrent,
  //   statusAgent
  // ) => {
  //   if (mediaid === 2) mediaid = 1;

  //   if (statusAgent.allowCall === false) {
  //     this.props.InterationNotifier("Pausa não permite ativo", "permission");
  //     return true;
  //   }

  //   if (document.getElementById("chat-message"))
  //     document.getElementById("chat-message").innerText = "";
  //   var existeRota = false;
  //   var trunk = "";
  //   var addtech = "";
  //   var scriptrunk = "";
  //   var operator = "";
  //   var teste = [];
  //   var idgrupo_rota = "";
  //   var checkAtd = false;
  //   var tech = "";

  //   var idgrupo_transb = "";
  //   var rotaDefault = false;
  //   var trunkDef = "";
  //   var addtechDef = "";
  //   var scriptrunkDef = "";
  //   var operatorDef = "";
  //   var techDef = "";
  //   var idgrupo_rotaDef = "";
  //   var idgrupo_transbDef = "";
  //   var rotaAlternativa = false;
  //   var tipochamada = 0;
  //   var dddValidado = "";
  //   if (
  //     permrouter[0].areacodeid != "undefined" &&
  //     permrouter[0].areacodeid != ""
  //   ) {
  //     var DDD = permrouter[0].areacodeid;
  //     var DDDPadrao = permrouter[0].areacodeid;
  //   } else {
  //     var DDD = "71";
  //     var DDDPadrao = "71";
  //   }

  //   var calledDigitado = chamado;
  //   var rotaencontrada = false;
  //   var checkRota = false;
  //   var valorfixo = [1, 2, 3, 4];
  //   var valormovel = [5, 6, 7, 8, 9];
  //   //var caracterAdicional = "";
  //   if (connection_platform.remove_digits || parseInt(mediaid) !== 1) {
  //     if (
  //       chamado[0] === "0" &&
  //       chamado.substr(0, 2) != "00" &&
  //       chamado.substr(0, 4) != "0800"
  //     ) {
  //       //caracterAdicional = chamado.substr(0,1);
  //       chamado = chamado.substr(1, chamado.length - 1);
  //     }
  //   }

  //   if (
  //     (chamado.length === 12 || chamado.length === 13) &&
  //     chamado.substr(0, 2) != "00"
  //   ) {
  //     if (chamado.substr(0, 2) === "55") {
  //       chamado = chamado.substr(2, chamado.length - 1);
  //       calledDigitado = calledDigitado.substr(2, calledDigitado.length - 1);
  //     }

  //     dddValidado = chamado.substr(2, 2);

  //     if (
  //       !connection_platform.remove_digits &&
  //       parseInt(mediaid) === 1 &&
  //       chamado.startsWith("0")
  //     ) {
  //       dddValidado = chamado.substr(1, 2);
  //     }

  //     if (parseInt(dddValidado) != parseInt(DDDPadrao)) {
  //       if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
  //         if (mediaid == 1) tipochamada = 3;
  //         else if (mediaid == 5) tipochamada = 17;
  //         else if (mediaid == 8) tipochamada = 19;
  //         else if (mediaid === 4) tipochamada = 18;
  //         else if (mediaid === 6) tipochamada = 20;
  //         else if (mediaid === 9) tipochamada = 21;
  //         else if (mediaid === 10) tipochamada = 23;
  //         else if (mediaid === 3) tipochamada = 22;
  //         else if (mediaid === 2) tipochamada = 24;
  //         else if (mediaid === 11) tipochamada = 25;
  //       } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
  //         if (mediaid == 1) tipochamada = 4;
  //         else if (mediaid == 5) tipochamada = 17;
  //         else if (mediaid == 8) tipochamada = 19;
  //         else if (mediaid === 4) tipochamada = 18;
  //         else if (mediaid === 6) tipochamada = 20;
  //         else if (mediaid === 9) tipochamada = 21;
  //         else if (mediaid === 10) tipochamada = 23;
  //         else if (mediaid === 3) tipochamada = 22;
  //         else if (mediaid === 2) tipochamada = 24;
  //         else if (mediaid === 11) tipochamada = 25;
  //       }
  //     } else if (parseInt(dddValidado) == parseInt(DDDPadrao)) {
  //       if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
  //         if (mediaid == 1) tipochamada = 1;
  //         else if (mediaid == 5) tipochamada = 17;
  //         else if (mediaid == 8) tipochamada = 19;
  //         else if (mediaid === 4) tipochamada = 18;
  //         else if (mediaid === 6) tipochamada = 20;
  //         else if (mediaid === 9) tipochamada = 21;
  //         else if (mediaid === 10) tipochamada = 23;
  //         else if (mediaid === 3) tipochamada = 22;
  //         else if (mediaid === 2) tipochamada = 24;
  //         else if (mediaid === 11) tipochamada = 25;
  //       } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
  //         if (mediaid == 1) tipochamada = 2;
  //         else if (mediaid == 5) tipochamada = 17;
  //         else if (mediaid == 8) tipochamada = 19;
  //         else if (mediaid === 4) tipochamada = 18;
  //         else if (mediaid === 6) tipochamada = 20;
  //         else if (mediaid === 9) tipochamada = 21;
  //         else if (mediaid === 10) tipochamada = 23;
  //         else if (mediaid === 3) tipochamada = 22;
  //         else if (mediaid === 2) tipochamada = 24;
  //         else if (mediaid === 11) tipochamada = 25;
  //       }
  //     }
  //   }
  //   if (
  //     (chamado.length === 10 || chamado.length === 11) &&
  //     chamado.substr(0, 3) != "800" &&
  //     chamado.substr(0, 2) != "00"
  //   ) {
  //     // DDD = chamado.substr(0, 2);
  //     // chamado = chamado.substr(2, chamado.length - 1);

  //     if (!connection_platform.remove_digits && chamado[0] === "0") {
  //       DDD = chamado.substr(1, 2);
  //       chamado = chamado.substr(3, chamado.length - 1);
  //     } else {
  //       DDD = chamado.substr(0, 2);
  //       chamado = chamado.substr(2, chamado.length - 1);
  //     }

  //     if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
  //       if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
  //         chamado = "9" + chamado;
  //       }
  //     }

  //     if (
  //       parseInt(parseInt(DDD)) != parseInt(DDDPadrao) &&
  //       chamado.substr(0, 2) != "00"
  //     ) {
  //       if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
  //         if (mediaid == 1) tipochamada = 3;
  //         else if (mediaid == 5) tipochamada = 17;
  //         else if (mediaid == 8) tipochamada = 19;
  //         else if (mediaid === 4) tipochamada = 18;
  //         else if (mediaid === 6) tipochamada = 20;
  //         else if (mediaid === 9) tipochamada = 21;
  //         else if (mediaid === 10) tipochamada = 23;
  //         else if (mediaid === 3) tipochamada = 22;
  //         else if (mediaid === 2) tipochamada = 24;
  //         else if (mediaid === 11) tipochamada = 25;
  //       } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
  //         if (mediaid == 1) tipochamada = 4;
  //         else if (mediaid == 5) tipochamada = 17;
  //         else if (mediaid == 8) tipochamada = 19;
  //         else if (mediaid === 4) tipochamada = 18;
  //         else if (mediaid === 6) tipochamada = 20;
  //         else if (mediaid === 9) tipochamada = 21;
  //         else if (mediaid === 10) tipochamada = 23;
  //         else if (mediaid === 3) tipochamada = 22;
  //         else if (mediaid === 2) tipochamada = 24;
  //         else if (mediaid === 11) tipochamada = 25;
  //       }
  //     } else if (parseInt(DDD) == parseInt(DDDPadrao)) {
  //       if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
  //         if (mediaid == 1) tipochamada = 1;
  //         else if (mediaid == 5) tipochamada = 17;
  //         else if (mediaid == 8) tipochamada = 19;
  //         else if (mediaid === 4) tipochamada = 18;
  //         else if (mediaid === 6) tipochamada = 20;
  //         else if (mediaid === 9) tipochamada = 21;
  //         else if (mediaid === 10) tipochamada = 23;
  //         else if (mediaid === 3) tipochamada = 22;
  //         else if (mediaid === 2) tipochamada = 24;
  //         else if (mediaid === 11) tipochamada = 25;
  //       } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
  //         if (mediaid == 1) tipochamada = 2;
  //         else if (mediaid == 5) tipochamada = 17;
  //         else if (mediaid == 8) tipochamada = 19;
  //         else if (mediaid === 4) tipochamada = 18;
  //         else if (mediaid === 6) tipochamada = 20;
  //         else if (mediaid === 9) tipochamada = 21;
  //         else if (mediaid === 10) tipochamada = 23;
  //         else if (mediaid === 3) tipochamada = 22;
  //         else if (mediaid === 2) tipochamada = 24;
  //         else if (mediaid === 11) tipochamada = 25;
  //       }
  //     }
  //     if (mediaid !== 8) {
  //       chamado = DDD + chamado;
  //       calledDigitado = DDD + calledDigitado;
  //     }
  //   } else if (chamado.length === 8 || chamado.length === 9) {
  //     if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
  //       if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
  //         chamado = "9" + chamado;
  //       }
  //     }

  //     if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
  //       if (mediaid == 1) tipochamada = 1;
  //       else if (mediaid == 5) tipochamada = 17;
  //       else if (mediaid == 8) tipochamada = 19;
  //       else if (mediaid === 4) tipochamada = 18;
  //       else if (mediaid === 6) tipochamada = 20;
  //       else if (mediaid === 9) tipochamada = 21;
  //       else if (mediaid === 10) tipochamada = 23;
  //       else if (mediaid === 3) tipochamada = 22;
  //       else if (mediaid === 2) tipochamada = 24;
  //       else if (mediaid === 11) tipochamada = 25;
  //     } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
  //       if (mediaid == 1) tipochamada = 2;
  //       else if (mediaid == 5) tipochamada = 17;
  //       else if (mediaid == 8) tipochamada = 19;
  //       else if (mediaid === 4) tipochamada = 18;
  //       else if (mediaid === 6) tipochamada = 20;
  //       else if (mediaid === 9) tipochamada = 21;
  //       else if (mediaid === 10) tipochamada = 23;
  //       else if (mediaid === 3) tipochamada = 22;
  //       else if (mediaid === 2) tipochamada = 24;
  //       else if (mediaid === 11) tipochamada = 25;
  //     }
  //     if (mediaid !== 1 && mediaid !== 8) {
  //       chamado = DDD + chamado;
  //       calledDigitado = DDD + calledDigitado;
  //     }
  //   } else if (chamado.substr(0, 3) == "800") {
  //     //chamado = '0'+chamado;
  //     tipochamada = 8;
  //   } else if (chamado.substr(0, 2) == "00") {
  //     if (mediaid == 1) tipochamada = 5;
  //     else if (mediaid == 5) tipochamada = 17;
  //     else if (mediaid == 8) tipochamada = 19;
  //     else if (mediaid === 4) tipochamada = 18;
  //     else if (mediaid === 6) tipochamada = 20;
  //     else if (mediaid === 9) tipochamada = 21;
  //     else if (mediaid === 10) tipochamada = 23;
  //     else if (mediaid === 3) tipochamada = 22;
  //     else if (mediaid === 2) tipochamada = 24;
  //     else if (mediaid === 11) tipochamada = 25;
  //   } else {
  //     permrouter.map((result) => {
  //       if (result.calltypeid == 11) {
  //         if (
  //           parseInt(chamado) >= parseInt(result.partialnumber) &&
  //           parseInt(chamado) <= parseInt(result.partialnumber_end)
  //         ) {
  //           tipochamada = 11;
  //         }
  //       } else if (result.calltypeid == 6) {
  //         if (parseInt(chamado) === parseInt(result.partialnumber)) {
  //           tipochamada = 6;
  //         }
  //       }
  //     });
  //   }

  //   if (mediaid === 4) tipochamada = 18;
  //   else if (mediaid === 6) tipochamada = 20;
  //   else if (mediaid === 9) tipochamada = 21;
  //   else if (mediaid === 10) tipochamada = 23;
  //   else if (mediaid === 3) tipochamada = 22;
  //   else if (mediaid === 2) tipochamada = 24;
  //   else if (mediaid === 11) tipochamada = 25;

  //   if (queue.status === "0") {
  //     // if (parseInt(mediaid) == 1) {
  //     permrouter.map((result) => {
  //       if (parseInt(result.idmidia) === parseInt(mediaid)) {
  //         if (parseInt(tipochamada) == result.calltypeid) {
  //           if (parseInt(tipochamada) == 1) {
  //             if (
  //               (parseInt(chamado) >=
  //                 parseInt(result.areacode + result.partialnumber) &&
  //                 chamado <=
  //                   parseInt(result.areacode + result.partialnumber_end)) ||
  //               parseInt(chamado) ==
  //                 parseInt(result.areacode + result.partialnumber)
  //             ) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               checkRota = true;
  //               existeRota = true;
  //             } else if (
  //               (parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) >=
  //                 parseInt(result.partialnumber) &&
  //                 chamado.substr(parseInt(chamado.length) - 8, 4) <=
  //                   parseInt(result.partialnumber_end)) ||
  //               parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) ==
  //                 parseInt(result.partialnumber)
  //             ) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               checkRota = true;
  //               existeRota = true;
  //             } else if (
  //               result.operator !== null &&
  //               result.operator != "" &&
  //               result.areacode ===
  //                 parseInt(chamado.substr(parseInt(chamado.length) - 10, 2))
  //             ) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               existeRota = true;
  //               checkRota = true;
  //             } else if (rotaencontrada == false) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               existeRota = true;
  //               checkRota = true;
  //             }
  //           } else if (parseInt(tipochamada) == 2) {
  //             if (
  //               (parseInt(chamado) >=
  //                 parseInt(result.areacode + result.partialnumber) &&
  //                 chamado <=
  //                   parseInt(result.areacode + result.partialnumber_end)) ||
  //               parseInt(chamado) ==
  //                 parseInt(result.areacode + result.partialnumber)
  //             ) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               checkRota = true;
  //               existeRota = true;
  //             } else if (
  //               (parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) >=
  //                 parseInt(result.partialnumber) &&
  //                 chamado.substr(parseInt(chamado.length) - 8, 4) <=
  //                   parseInt(result.partialnumber_end)) ||
  //               parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) ==
  //                 parseInt(result.partialnumber)
  //             ) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               checkRota = true;
  //               existeRota = true;
  //             } else if (
  //               result.operator !== null &&
  //               result.operator != "" &&
  //               result.areacode ===
  //                 parseInt(chamado.substr(parseInt(chamado.length) - 11, 2))
  //             ) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               existeRota = true;
  //               checkRota = true;
  //             } else if (rotaencontrada == false) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               existeRota = true;
  //               checkRota = true;
  //             }
  //           } else if (parseInt(tipochamada) == 3) {
  //             if (
  //               (parseInt(chamado) >=
  //                 parseInt(result.areacode + result.partialnumber) &&
  //                 chamado <=
  //                   parseInt(result.areacode + result.partialnumber_end)) ||
  //               parseInt(chamado) ==
  //                 parseInt(result.areacode + result.partialnumber)
  //             ) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               checkRota = true;
  //               existeRota = true;
  //             } else if (
  //               (parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) >=
  //                 parseInt(result.partialnumber) &&
  //                 chamado.substr(parseInt(chamado.length) - 8, 4) <=
  //                   parseInt(result.partialnumber_end)) ||
  //               parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) ==
  //                 parseInt(result.partialnumber)
  //             ) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               checkRota = true;
  //               existeRota = true;
  //             } else if (
  //               parseInt(chamado.substr(parseInt(chamado.length) - 10, 2)) ==
  //               parseInt(result.areacode)
  //             ) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               checkRota = true;
  //               existeRota = true;
  //             } else if (rotaencontrada == false) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               existeRota = true;
  //               checkRota = true;
  //             }
  //           } else if (parseInt(tipochamada) == 4) {
  //             if (
  //               (parseInt(chamado) >=
  //                 parseInt(result.areacode + result.partialnumber) &&
  //                 chamado <=
  //                   parseInt(result.areacode + result.partialnumber_end)) ||
  //               parseInt(chamado) ==
  //                 parseInt(result.areacode + result.partialnumber)
  //             ) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               existeRota = true;
  //               checkRota = true;
  //             } else if (
  //               (parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) >=
  //                 parseInt(result.partialnumber) &&
  //                 chamado.substr(parseInt(chamado.length) - 8, 4) <=
  //                   parseInt(result.partialnumber_end)) ||
  //               parseInt(chamado.substr(parseInt(chamado.length) - 8, 4)) ==
  //                 parseInt(result.partialnumber)
  //             ) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               checkRota = true;
  //               existeRota = true;
  //             } else if (
  //               parseInt(chamado.substr(parseInt(chamado.length) - 11, 2)) ==
  //               parseInt(result.areacode)
  //             ) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               checkRota = true;
  //               existeRota = true;
  //             } else if (rotaencontrada == false) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               existeRota = true;
  //               checkRota = true;
  //             }
  //           } else if (parseInt(tipochamada) == 5) {
  //             if (rotaencontrada == false) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               existeRota = true;
  //               checkRota = true;
  //             }
  //           } else if (parseInt(tipochamada) == 8) {
  //             if (rotaencontrada == false) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               existeRota = true;
  //               checkRota = true;
  //             }
  //           } else if (
  //             parseInt(tipochamada) != 5 &&
  //             chamado.substr(0, 2) == "00" &&
  //             parseInt(result.operator) == parseInt(chamado.substr(0, 2))
  //           ) {
  //             trunk = result.idtrunk;
  //             addtech = result.addtech;
  //             scriptrunk = result.scripttrunk;
  //             operator = "";
  //             tech = result.tech;
  //             idgrupo_rota = result.idgrupo_rota;
  //             idgrupo_transb = result.idgrupo_transb;
  //             rotaencontrada = true;
  //             existeRota = true;
  //             checkRota = true;
  //           } else if (parseInt(tipochamada) == 11) {
  //             permrouter.map((result) => {
  //               if (result.calltypeid == 11) {
  //                 if (
  //                   parseInt(chamado) >= parseInt(result.partialnumber) &&
  //                   parseInt(chamado) <= parseInt(result.partialnumber_end)
  //                 ) {
  //                   trunk = result.idtrunk;
  //                   addtech = result.addtech;
  //                   scriptrunk = result.scripttrunk;
  //                   operator = "";
  //                   tech = result.tech;
  //                   idgrupo_rota = result.idgrupo_rota;
  //                   idgrupo_transb = result.idgrupo_transb;
  //                   rotaencontrada = true;
  //                   existeRota = true;
  //                   checkRota = true;
  //                 }
  //               }
  //             });
  //           } else if (parseInt(tipochamada) == 6) {
  //             permrouter.map((result) => {
  //               if (result.calltypeid == 6) {
  //                 if (parseInt(chamado) === parseInt(result.partialnumber)) {
  //                   trunk = result.idtrunk;
  //                   addtech = result.addtech;
  //                   scriptrunk = result.scripttrunk;
  //                   operator = "";
  //                   tech = result.tech;
  //                   idgrupo_rota = result.idgrupo_rota;
  //                   idgrupo_transb = result.idgrupo_transb;
  //                   rotaencontrada = true;
  //                   existeRota = true;
  //                   checkRota = true;
  //                 }
  //               }
  //             });
  //           } else {
  //             if (rotaencontrada == false) {
  //               trunk = result.idtrunk;
  //               addtech = result.addtech;
  //               scriptrunk = result.scripttrunk;
  //               operator = result.operator;
  //               tech = result.tech;
  //               idgrupo_rota = result.idgrupo_rota;
  //               idgrupo_transb = result.idgrupo_transb;
  //               rotaencontrada = true;
  //               existeRota = true;
  //             }
  //           }
  //         }
  //       }
  //     });

  //     AtdSimult.map((atend) => {
  //       if (
  //         String(atend.telefone) === String(chamado) &&
  //         parseInt(mediaid) === parseInt(atend.idmidia)
  //       )
  //         checkAtd = true;
  //     });
  //     if (checkAtd == false) {
  //       if (existeRota == true) {
  //         var queueid = queue.queueid;
  //         var recvcount = queue.recv_count;
  //         var cdrid = queue.cdrid;
  //         var callback_count = queue.callback_count;
  //         var srvin = queue.serviceinid;
  //         var caller = queue.caller;
  //         var called = queue.called;
  //         var cbackcount = queue.callback_count;
  //         var status = queue.status;
  //         if (parseInt(mediaid) == 1) {
  //           this.props.RequestActiveCallSocketVoz(
  //             outband,
  //             infouser,
  //             trunk,
  //             mediaid,
  //             chamado,
  //             addtech,
  //             scriptrunk,
  //             operator,
  //             true,
  //             queueid,
  //             recvcount,
  //             callback_count,
  //             tech,
  //             idgrupo_rota,
  //             idgrupo_transb,
  //             ipcurrent,
  //             cdrid,
  //             checkRota
  //           );
  //           this.props.ReturningCallbackIn(
  //             queueid,
  //             true,
  //             recvcount,
  //             cdrid,
  //             mediaid,
  //             srvin,
  //             caller,
  //             called,
  //             cbackcount,
  //             status
  //           );
  //           this.props.ShowInfoDisplay("Clientes");
  //         } else {
  //           this.props.RequestActiveCall(
  //             outband,
  //             infouser,
  //             trunk,
  //             mediaid,
  //             chamado,
  //             addtech,
  //             scriptrunk,
  //             operator,
  //             true,
  //             queueid,
  //             recvcount,
  //             callback_count,
  //             idgrupo_rota,
  //             cdrid
  //           );
  //           this.props.ReturningCallbackIn(
  //             queueid,
  //             true,
  //             recvcount,
  //             cdrid,
  //             mediaid,
  //             srvin,
  //             caller,
  //             called,
  //             callback_count
  //           );
  //           this.props.ShowInfoDisplay("Clientes");
  //         }
  //       } else {
  //         this.props.InterationNotifier("Sem rota de sa&iacute;da!", "call");
  //       }
  //     } else {
  //       this.props.InterationNotifier(
  //         "Este cliente já está sendo atendido por você",
  //         "call"
  //       );
  //     }
  //   } else {
  //     this.props.InterationNotifier(
  //       "Chamada já está sendo retornada por " + queue.username,
  //       "call"
  //     );
  //   }
  // };

  // SolicitarChamadaAtiva = (
  //   e,
  //   permrouter,
  //   mediaid,
  //   status,
  //   infouser,
  //   chamado,
  //   outband,
  //   queue,
  //   AtdSimult,
  //   ipcurrent,
  //   statusAgent
  // ) => {

  SolicitarChamadaAtiva = (
    e,
    permrouter,
    mediaid,
    callStatus,
    infouser,
    number,
    outband,
    queue,
    AtdSimult,
    ipcurrent,
    statusAgent
  ) => {
    document.getElementById("div_alert").innerHTML = "";

    if (this.props.ContactId.length !== 0) {
      localStorage.setItem(
        "current-service",
        this.props.ContactId.idatendimento
      );
    }

    if (statusAgent.allowCall === false) {
      this.props.InterationNotifier("Pausa não permite ativo", "permission");
      return true;
    }

    const chatMessage = document.getElementById("chat-message");
    if (chatMessage) chatMessage.innerText = "";

    if (!permrouter || permrouter.length === 0) return;

    let chamado = number.replace(/\D/g, "");
    let tipochamada = 0;
    let DDD = permrouter[0].areacodeid || "71";

    const valorfixo = [1, 2, 3, 4],
      valormovel = [5, 6, 7, 8, 9];
    const removeDigits =
      connection_platform.remove_digits || parseInt(mediaid) !== 1;

    if (
      removeDigits &&
      chamado.startsWith("0") &&
      !chamado.startsWith("00") &&
      !chamado.startsWith("0800")
    ) {
      chamado = chamado.substring(1);
    }

    function definirTipoChamada(mediaid, tipo) {
      const tipos = {
        fixoInterurbano: [3, 17, 19, 18, 20, 21, 23, 22, 24, 25],
        movelInterurbano: [4, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
        fixoLocal: [1, 17, 19, 18, 20, 21, 23, 22, 24, 25],
        movelLocal: [2, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
      };

      // Converte mediaid para inteiro
      const midiaConvertida = parseInt(mediaid, 10);

      // Se mediaid for 1, busca no objeto `tipos`, senão segue a lógica específica
      if (midiaConvertida === 1) {
        return tipos[tipo] ? tipos[tipo][midiaConvertida - 1] || 0 : 0;
      } else {
        const mapeamentoMidia = {
          2: 24,
          3: 22,
          4: 18,
          5: 17,
          6: 20,
          8: 19,
          9: 21,
          10: 23,
          12: 13,
          15: 26,
        };

        return mapeamentoMidia[midiaConvertida] || midiaConvertida;
      }
    }

    if (
      (chamado.length >= 10 || chamado.length === 8 || chamado.length === 9) &&
      !chamado.startsWith("00")
    ) {
      if (
        chamado.startsWith("55") &&
        (mediaid === 5 || mediaid === "5") &&
        chamado.length > 11
      )
        chamado = chamado.substr(2);
      if (chamado.length === 8 || chamado.length === 9) chamado = DDD + chamado;
    }

    let chamadoValidado = chamado.replace(/^0(?!0|800|300)/, "");
    console.log("INGENIUM_ACTVECALL_0 : ", chamado);

    let dddValidado =
      chamadoValidado.length >= 10 ? chamadoValidado.substr(0, 2) : "";

    console.log("INGENIUM_ACTVECALL_1 : ", chamadoValidado);

    if (
      chamadoValidado.length >= 10 &&
      !chamadoValidado.startsWith("00") &&
      !chamadoValidado.startsWith("0800")
    ) {
      if (valorfixo.includes(parseInt(chamadoValidado[2]))) {
        tipochamada = definirTipoChamada(
          mediaid,
          dddValidado && parseInt(dddValidado) !== parseInt(DDD)
            ? "fixoInterurbano"
            : "fixoLocal"
        );
      } else if (valormovel.includes(parseInt(chamadoValidado[2]))) {
        tipochamada = definirTipoChamada(
          mediaid,
          dddValidado && parseInt(dddValidado) !== parseInt(DDD)
            ? "movelInterurbano"
            : "movelLocal"
        );
      }
    } else if (chamadoValidado.startsWith("0800")) {
      tipochamada = 8;
    } else if (chamadoValidado.startsWith("00")) {
      tipochamada = 5;
    }

    console.log("INGENIUM_ACTVECALL_2 : ", tipochamada);

    function buscarRota() {
      let rota = [];

      console.log("INGENIUM_ACTVECALL_1 : ", permrouter);

      const doisPrimeirosDigitos = chamadoValidado.substring(0, 2);

      // Só verifica `areacode` se `mediaid` for 1
      const verificarAreacode = parseInt(mediaid) === 1;

      // Verifica se existe pelo menos um item com areacode correspondente (somente se `mediaid` for 1)
      const existeAreaCode = verificarAreacode
        ? permrouter.some(
            (result) =>
              result.areacode &&
              String(result.areacode).startsWith(doisPrimeirosDigitos)
          )
        : false;

      permrouter.forEach((result) => {
        if (
          result.calltypeid === tipochamada &&
          parseInt(result.idmidia) === parseInt(mediaid) &&
          (!verificarAreacode ||
            !existeAreaCode ||
            (result.areacode &&
              String(result.areacode).startsWith(doisPrimeirosDigitos)))
        ) {
          rota.push(result);
        }
        if (result.calltypeid === 11 && !rota) {
          if (
            parseInt(chamado) >= parseInt(result.partialnumber) &&
            parseInt(chamado) <= parseInt(result.partialnumber_end)
          ) {
            rota.push(result);
          }
        } else if (result.calltypeid === 6 && !rota) {
          if (parseInt(chamado) === parseInt(result.partialnumber)) {
            rota.push(result);
          }
        }
      });

      if (rota && rota.length > 1) {
        let isExistOther = false;
        rota.forEach((result) => {
          const lastEight = String(chamado).slice(-8);
          if (
            parseInt(lastEight) >= parseInt(result.partialnumber) &&
            parseInt(lastEight) <= parseInt(result.partialnumber_end)
          ) {
            rota = result;
            isExistOther = true;
          }
        });
        if (!isExistOther) {
          rota = rota.filter((temp) => temp.isdefault === "t");
          rota = rota.length !== 0 ? rota[0] : [];
        }
      } else if (rota.length === 1) {
        rota = rota[0];
      }

      return rota;
    }

    const rotaEncontrada = buscarRota();

    console.log("INGENIUM_ACTVECALL_4 : ", rotaEncontrada);

    if (rotaEncontrada.length === 0) {
      this.setState({ senhaincorreta: "block" });
      document.getElementById("div_alert").innerHTML = "Sem rota de saída!";
      return;
    }

    let retorno = 1;
    let queueid = queue && queue.queueid ? queue.queueid : null;
    let recvcount = queue && queue.recv_count ? queue.recv_count : null;
    let cdrid = queue && queue.cdrid ? queue.cdrid : null;
    let srvin = queue && queue.serviceinid ? queue.serviceinid : null;
    let caller = queue && queue.caller ? queue.caller : null;
    let called = queue && queue.called ? queue.called : null;
    let cbackcount =
      queue && queue.callback_count ? queue.callback_count : null;
    let queueStatus = queue && queue.status ? queue.status : null;
    let tech = rotaEncontrada.tech;
    let idgrupo_rota = rotaEncontrada.idgrupo_rota;
    let idgrupo_transb = rotaEncontrada.idgrupo_transb;
    let checkRota = true;

    if (mediaid === 5 || mediaid === 8) {
      chamado = chamado.trim();
    }

    console.log("INGENIUM_ACTVECALL_5 : ", chamado);

    if (mediaid === 1) {
      this.props.RequestActiveCallSocketVoz(
        outband,
        infouser,
        rotaEncontrada.idtrunk,
        mediaid,
        chamado,
        rotaEncontrada.addtech,
        rotaEncontrada.scripttrunk,
        rotaEncontrada.operator,
        true,
        queueid,
        recvcount,
        null,
        tech,
        idgrupo_rota,
        idgrupo_transb,
        ipcurrent,
        cdrid,
        checkRota
      );
      this.props.ReturningCallbackIn(
        queueid,
        true,
        recvcount,
        cdrid,
        mediaid,
        srvin,
        caller,
        called,
        cbackcount,
        queueStatus
      );
    } else {
      this.props.RequestActiveCall(
        outband,
        infouser,
        rotaEncontrada.idtrunk,
        mediaid,
        chamado,
        rotaEncontrada.addtech,
        rotaEncontrada.scripttrunk,
        rotaEncontrada.operator,
        true,
        queueid,
        recvcount,
        cbackcount,
        idgrupo_transb,
        cdrid
      );
      this.props.ReturningCallbackIn(
        queueid,
        true,
        recvcount,
        cdrid,
        mediaid,
        srvin,
        caller,
        called,
        cbackcount,
        queueStatus
      );
    }
    this.props.ShowInfoDisplay("Clientes");
  };

  ShowVisible(display) {
    this.props.ShowVisibleNextAtdIn(display, display);
    // MicroModal.show('modal__encerrar-atendimento')
  }

  RefreshNoAnswer(e, cdrid, queueid, infousers, queue) {
    this.props.PropsRefreshNoAnswer(cdrid, queueid, infousers, queue);
    document.getElementById("simulation_click").click();
  }

  renderPopover = (
    e,
    numberqueue,
    contactname,
    cdrid,
    queueid,
    queue,
    infousers,
    actionPermission
  ) => {
    return (
      <div className="context-menu new-context" id="info-fila">
        <ul className="context-menu__list">
          {(() => {
            if (!actionPermission) {
              return (
                <>
                  {infousers.view_queue_interaction === true && (
                    <li
                      className="context-menu__item"
                      onClick={(event) =>
                        this.ShowModals(
                          e,
                          numberqueue,
                          contactname,
                          "modal__historico-atendimento-queue",
                          cdrid,
                          queueid,
                          queue
                        )
                      }
                    >
                      <Interacoes />
                      <span className="context-menu_link">Interações</span>
                    </li>
                  )}
                  <li
                    className="context-menu__item"
                    onClick={(event) =>
                      this.ShowModals(
                        e,
                        numberqueue,
                        contactname,
                        "modal__anotacoes",
                        cdrid,
                        queueid,
                        queue
                      )
                    }
                  >
                    <Anotacoes />
                    <span className="context-menu_link">Anotações</span>
                  </li>

                  <li
                    className="context-menu__item"
                    onClick={(event) =>
                      this.ShowModals(
                        e,
                        numberqueue,
                        contactname,
                        "modal__mensagens-favoritas",
                        cdrid,
                        queueid,
                        queue
                      )
                    }
                  >
                    <MsgFavoritas />
                    <span className="context-menu_link">
                      Mensagens favoritas
                    </span>
                  </li>
                  <li
                    className="context-menu__item"
                    onClick={(event) =>
                      this.ShowModals(
                        e,
                        numberqueue,
                        contactname,
                        "modal__arquivos-compartilhados",
                        cdrid,
                        queueid,
                        queue
                      )
                    }
                  >
                    <ArquivosComp />
                    <span className="context-menu_link">
                      Arquivos compartilhados
                    </span>
                  </li>
                  {/* <li className="context-menu__item">
                    <Mapa />
                    <span className="context-menu_link">Mapa</span>
                  </li> */}
                </>
              );
            } else {
              return (
                <>
                  {parseInt(queue.status) === 1 && (
                    <li
                      className="context-menu__item"
                      onClick={(event) =>
                        this.ShowModals(
                          e,
                          numberqueue,
                          contactname,
                          "modal__transferir__chamada",
                          cdrid,
                          queueid,
                          queue
                        )
                      }
                    >
                      <Transferir />
                      <span className="context-menu_link">Transferir</span>
                    </li>
                  )}

                  {infousers.supervisor === true && queue.status != "1" && (
                    <li
                      className="context-menu__item item-excluir"
                      onClick={(event) =>
                        this.ShowModals(
                          e,
                          numberqueue,
                          contactname,
                          "modal__excluir",
                          cdrid,
                          queueid,
                          queue
                        )
                      }
                    >
                      <AlterarExcluir />
                      <span className="context-menu_link">Excluir chamada</span>
                    </li>
                  )}

                  {infousers.supervisor === true && queue.status != "0" && (
                    <li
                      className="context-menu__item"
                      onClick={(event) =>
                        this.RefreshNoAnswer(
                          e,
                          cdrid,
                          queueid,
                          infousers,
                          queue
                        )
                      }
                    >
                      <AlterarExcluir />
                      <span className="context-menu_link">
                        Alterar para não atendida
                      </span>
                    </li>
                  )}
                </>
              );
            }
          })()}
        </ul>
      </div>
    );
  };

  ShowCriticitys(e) {
    e.preventDefault();
    this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  SelectCriticitys(e, desccriticidade, idcriticidade, tipocriticidade) {
    this.setState({
      critSelec: desccriticidade,
      iconCrit: tipocriticidade,
      idCrit: idcriticidade,
    });
    this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  SelectCriticitys2(e, desccriticidade, idcriticidade, tipocriticidade) {
    this.setState({ SelecCritic: desccriticidade, idCrit2: idcriticidade });
    this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  ShowModals(e, numberqueue, contactname, modal, cdrid, queueid, queue) {
    this.ShowNameCli(numberqueue, contactname);
    this.setState({ modalOpen: modal, queueModalOpen: queueid });
    this.props.GetInteractionsModal(contactname, numberqueue);

    switch (modal) {
      case "modal__anotacoes":
        this.buttonSearchAnotation(e, numberqueue);
        MicroModal.show("modal__anotacoes-details-new");
        break;
      case "modal__arquivos-compartilhados":
        this.buttonSearchFileCompart(e, numberqueue);
        MicroModal.show("modal__arquivos-compartilhados-details");
        break;
      case "modal__mensagens-favoritas":
        this.buttonSearchMarkstar(e, numberqueue);
        MicroModal.show("modal__mensagens-favoritas-details");
        break;
      case "modal__historico-atendimento-queue":
        this.props.ClearHistory();
        const agora = Moment().subtract(7, "days");
        let histstart = agora.format("YYYY-MM-DDT00:00");
        let histend = Moment().format("YYYY-MM-DDT23:59");

        this.DisplayHistoric(numberqueue);
        MicroModal.show("modal__historico-atendimento-details");
        this.setState({
          clientpdf: numberqueue,
          datapdfend: histend,
          datapdfinit: histstart,
          cliente: contactname,
        });
        break;
      case "modal__excluir":
        MicroModal.show("modal__excluir");
        this.setState({
          deletequeueid: cdrid,
          deletecdrid: queueid,
          mediaid: queue.mediaid,
        });
        break;
      case "modal__transferir__chamada":
        this.setState({
          cdrid: cdrid,
          scriptid: queue.scriptid,
          mediaid: queue.mediaid,
          queueId: queueid,
        });
        MicroModal.show("modal__transferir__chamada");
        break;
      default:
        break;
    }
  }

  buttonSearchMarkstar(e, telefone) {
    var erro = 0;
    let now = Moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = Moment().format("YYYY-MM-DD");

    var comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      this.props.DetailsMarkstarida(datainit, datafim, telefone);
    }
  }

  SearchInHistory(e) {
    e.preventDefault();
    this.setState({ showHistory: !this.state.showHistory });
  }

  checkExpandLearnQueue(e, idanot) {
    var checkClick =
      this.state.expandLearn.indexOf(idanot) != -1 ? true : false;

    if (!checkClick) {
      this.setState({
        expandLearn: this.state.expandLearn.concat([idanot]),
      });
    } else {
      this.setState({
        expandLearn: this.state.expandLearn.filter(function (val) {
          return val != idanot;
        }),
      });
    }
  }

  showExpandVisual(e, idarq) {
    var click =
      this.state.optionsActionsFile.indexOf(idarq) != -1 ? true : false;

    if (!click) {
      this.setState({
        optionsActionsFile: this.state.optionsActionsFile.concat([idarq]),
      });
    } else {
      this.setState({
        optionsActionsFile: this.state.optionsActionsFile.filter(function (
          val
        ) {
          return val != idarq;
        }),
      });
    }
  }

  ShowNameCli(numberqueue, contactname) {
    this.setState({ numberqueue: numberqueue });
    if (contactname) {
      var mensagem_tratada = createJSON(contactname);
      this.setState({ nameCli: mensagem_tratada });
    } else {
      this.setState({ nameCli: numberqueue });
    }
  }

  ShowChoiceFormat(e) {
    e.preventDefault();
    this.setState({ buttonShowFormatsFile: !this.state.buttonShowFormatsFile });
  }

  choiceFormat(event, formats, name) {
    this.mimetypeids.value = formats;
    this.setState({
      buttonShowFormatsFile: !this.state.buttonShowFormatsFile,
      defaultValueFormat: name,
    });
  }

  choiceMidia(event, midias, name) {
    this.midias.value = midias;
    this.setState({
      buttonShowMidias: !this.state.buttonShowMidias,
      defaultValueMidias: name,
    });
  }

  ShowChoiceMidias(e) {
    e.preventDefault();
    this.setState({ buttonShowMidias: !this.state.buttonShowMidias });
  }

  DonwloadFile(e, url, name) {
    e.preventDefault();
    this.props.DonwloadFileIn(url, name);
  }

  handleScroll = (e) => {
    let element = e.target;
    let elmnt = document.getElementsByClassName("time");
  };

  VerifierImage(e, urlimage, modal) {
    this.setState({ isOpen: true, urlimage: urlimage });
    if (modal === "history") {
      MicroModal.close("modal__historico-atendimento-queue");
    }
    if (modal === "dmark") {
      MicroModal.close("modal__mensagens-favoritas");
    }
  }

  CloseImage(e, modal) {
    this.setState({ isOpen: false, urlimage: "" });
    if (modal === "history") {
      MicroModal.show("modal__historico-atendimento-queue");
    }
    if (modal === "dmark") {
      MicroModal.show("modal__mensagens-favoritas");
    }
  }

  ScrollView = (e) => {
    let element = e.target;
    let valueScroll = element.scrollTop + element.clientHeight;
    if (element.scrollHeight === valueScroll) {
      this.setState({ scrollEnd: this.state.scrollEnd + 4 });
    }
  };

  setVisibleDrawer(bind) {
    bind.setState({ openDrawer: false });
  }

  RemoveAllFilterQueue(e) {
    let array = this.state.typequeue;
    for (let i = 0; i < array.length; i++) {
      var myCheckbox = document.getElementById("input" + array[i]);
      myCheckbox.checked = false;
    }
    localStorage.setItem("filtro_fila", []);
  }

  RemoveAllFilterMedia(e) {
    let array = this.state.midias;
    for (let i = 0; i < array.length; i++) {
      var myCheckbox = document.getElementById("input" + array[i].describer);
      myCheckbox.checked = false;
    }
    localStorage.setItem("clients_queue_media", []);
  }

  renderItemQueue(
    IPCurrent,
    InfoUsers,
    StatusAgent,
    AtdSimult,
    OutBandService,
    PermissionRouter,
    callpark,
    initialDate,
    finalDate
  ) {
    if (this.state.tabNextCallInfo.isActive) {
      return (
        <div style={{ height: "100%", overflow: "hidden" }}>
          {/* <div className="queue-new-v2-top-bar-wraper">
          
        </div> */}

          <div
            className="block-content overflow flex-column list new"
            onScroll={this.ScrollView}
          >
            {this.state.callqueue.map((queue) => {
              const queueItemProps = {
                queue,
                IPCurrent,
                InfoUsers,
                StatusAgent,
                AtdSimult,
                OutBandService,
                PermissionRouter,
                expandQueue: this.state.expandQueue,
                buttonDetails: this.state.buttonDetails,
                callpark,
              };
              return (
                <QueueItem
                  key={queue.queueid}
                  checkExpandQueue={this.checkExpandQueue}
                  renderPopover={this.renderPopover}
                  SolicitarChamada={this.props.SolicitarChamada}
                  SolicitarChamadaAtiva={this.SolicitarChamadaAtiva}
                  ShowInfoDisplay={this.props.ShowInfoDisplay}
                  {...queueItemProps}
                />
              );
            })}
          </div>
        </div>
      );
    } else if (this.state.tabWaitingInfo.isActive) {
      return (
        <QuarentineZoneContent
          filteredListQuarentineQueue={this.state.filteredListQuarentineQueue}
          textToFilter={this.state.filterQuarentineQueue}
          filtermediastorage={filtermediastorage}
          initialDate={initialDate}
          finalDate={finalDate}
          onClickInFilter={() =>
            this.setState({
              openDrawer: true,
            })
          }
        />
      );
    } else {
      return (
        <ChatsContent
          key={this.state.filterQuarentineQueue}
          searchChats={this.state.filterQuarentineQueue}
          showModals={this.ShowModals}
        />
      );
    }
  }

  render() {
    const {
      listCallQueue,
      InfoUsers,
      PermissionRouter,
      CallBack,
      StatusAgent,
      OutBandService,
      DisplayNextAtd,
      History,
      DetailsAnotations,
      CriticidadesAnotacoes,
      IPCurrent,
      DetailsMarkstar,
      DetailsFileShared,
      AtdSimult,
      Filters,
      InfoDisplay,
      callpark,
      ListQueuePermission,
      ContactId,
      exhibDrawer,
    } = this.props;
    const { searchText, initialDate, finalDate } = this.state;
    const searchWords = searchText.split(/\s/).filter((word) => word);
    let nomesDasFilas = [];
    let totalMsgsChats = 0;
    const isQuarentineZone =
      this.state.tabWaitingInfo.isActive || this.state.tabChatsInfo.isActive;

    if (ListQueuePermission.queuepermission) {
      const idsDasFilas = new Set();
      // listCallQueue.forEach((cliente) => {
      //   const nomeDaFila = getInfoQueue(
      //     ListQueuePermission.queuepermission,
      //     cliente.serviceinid
      //   );
      //   if (nomeDaFila && !idsDasFilas.has(nomeDaFila.id)) {
      //     idsDasFilas.add(nomeDaFila.id);
      //     nomesDasFilas.push(nomeDaFila);
      //   }
      // });

      ListQueuePermission.queuepermission.forEach((queue) => {
        const nomeDaFila = getInfoQueue2(queue);
        if (nomeDaFila && !idsDasFilas.has(nomeDaFila.id)) {
          idsDasFilas.add(nomeDaFila.id);
          nomesDasFilas.push(nomeDaFila);
        }
      });
      this.state.subservicesList = nomesDasFilas;
    }

    this.timedefaultinitqueue = Moment().format("YYYY-MM-DDT00:00");
    this.timedefaultfimqueue = Moment().format("YYYY-MM-DDT23:59");
    this.datatimeinitqueue = Moment().format("YYYY-MM-DD");
    this.datatimefimqueue = Moment().format("YYYY-MM-DD");
    this.timearqinitqueue = Moment().format("YYYY-MM-DD");
    this.timearqfimqueue = Moment().format("YYYY-MM-DD");
    this.datainitqueue = Moment().format("YYYY-MM-DD");
    this.datafimqueue = Moment().format("YYYY-MM-DD");

    if (DisplayNextAtd.length !== 0 || exhibDrawer) {
      if (
        DisplayNextAtd.displaynextatd === true ||
        (DisplayNextAtd.displaynextatd === "ocultar" &&
          InfoDisplay.infodisplay === "Equipes") ||
        exhibDrawer
      ) {
        this.state.visible = " active";
      } else if (DisplayNextAtd.displaynextatd === false) {
        this.state.visible = " w-40";
      } else if (
        DisplayNextAtd.displaynextatd === "ocultar" &&
        InfoDisplay.infodisplay === "Clientes"
      ) {
        this.state.visible = " w-40";
      } else {
        this.state.visible = " w-40";
      }
    }

    if (listCallQueue.length != 0) {
      this.state.callqueue = listCallQueue;

      if (Filters.length != 0) {
        if (Filters.array_fila.length !== 0) {
          let filtroArr = Filters.array_fila;
          this.state.callqueue = this.state.callqueue.filter((queue) =>
            filtroArr.includes(queue.status)
          );
        }
      }
      if (this.state.typemedia != "") {
        this.state.callqueue = this.state.callqueue.filter((queue) =>
          this.state.typemedia.includes(queue.mediaid)
        );
      }
      if (this.state.typesubservice.length !== 0) {
        this.state.callqueue = this.state.callqueue.filter((queue) =>
          this.state.typesubservice.includes(queue.serviceinid)
        );
      }
    } else {
      this.state.callqueue = [];
    }

    if (this.state.modalOpen) {
      const findQueue = this.state.callqueue.find(
        (queue) =>
          parseInt(queue.queueid) === parseInt(this.state.queueModalOpen)
      );
      if (!findQueue) {
        MicroModal.close(this.state.modalOpen);
        this.setState({ modalOpen: false, queueModalOpen: "" });
      }
    }

    const list = this.state.callqueue || [];

    this.state.callqueue = _.filter(list, (queue) => {
      let arrayQueue = [
        queue.caller,
        queue.called,
        queue.to_char,
        queue.recv_count,
        queue.contactname,
        queue.username,
      ];
      return !_.isEmpty(this.state.filterQueue)
        ? arrayQueue
            .toString()
            .toLowerCase()
            .indexOf(this.state.filterQueue.toString().toLowerCase()) > -1
        : true;
    });

    if (CriticidadesAnotacoes.length != 0) {
      this.state.DescAnotacoes = CriticidadesAnotacoes.criticalitys;
      if (this.state.idCrit2 === 0) {
        this.state.iconeCriticidade =
          this.state.DescAnotacoes[0].class_criticality;
        this.state.SelecCritic = this.state.DescAnotacoes[0].description;
        this.state.idCrit2 = this.state.DescAnotacoes[0].id;
      }
    }

    if (listCallQueue.length != 0) {
      this.state.callqueue.reverse(function (obj1, obj2) {
        return obj1.to_char > obj2.to_char
          ? 1
          : obj2.to_char > obj1.to_char
          ? -1
          : 0;
      });
    } else {
      this.state.callqueue = [];
    }

    if (DetailsAnotations.length != 0) {
      this.state.detailsAnotations = DetailsAnotations.detailsanotations;
      this.state.totalAnotations = this.state.detailsAnotations.length;
    } else {
      this.state.detailsAnotations = [];
      this.state.totalAnotations = 0;
    }

    if (DetailsMarkstar.length != 0) {
      this.state.detailsMarkstar = DetailsMarkstar.detailsmarkstars;
      this.state.totalMarkstar = this.state.detailsMarkstar.length;
    } else {
      this.state.detailsMarkstar = [];
      this.state.totalMarkstar = 0;
    }

    if (DetailsFileShared.length != 0) {
      this.state.detailsFileShared = DetailsFileShared.detailsfileshared;
      this.state.totalFiles = this.state.detailsFileShared.length;
    } else {
      this.state.detailsFileShared = [];
      this.state.totalFiles = 0;
    }

    if (History.length) {
      this.state.history = History;
      let testarultimo = 0;
      var total = this.state.history[0];
      this.state.totalhistory = total.interacoes;
    } else {
      this.state.history = [];
    }

    if (IPCurrent.length !== 0) {
      this.state.midias = IPCurrent.midias;
    }

    if (InfoUsers.user_midias)
      this.state.callqueue = this.state.callqueue.filter((queue) =>
        InfoUsers.user_midias.includes(queue.mediaid)
      );

    if (listCallQueue.length != 0) {
      if (this.state.typemedia != "") {
        this.state.callqueue = this.state.callqueue.filter((queue) =>
          this.state.typemedia.includes(queue.mediaid)
        );
      }
    }

    if (listCallQueue.length != 0 && parseInt(InfoUsers.tmcallback) > 0) {
      if (StatusAgent.status === "Pausado") {
        clearInterval(statusIntervalCBack);
        checkCallBack = false;
      } else if (StatusAgent.status === "Livre") {
        if (!checkCallBack) {
          // Ordena primeiro por callback_count e, em caso de empate, pela data/hora mais distante da atual
          this.state.callqueue.sort((a, b) => {
            // Ordena por callback_count em ordem crescente
            const callbackCountDiff =
              parseInt(a.callback_count) - parseInt(b.callback_count);

            if (callbackCountDiff !== 0) {
              return callbackCountDiff;
            }

            // Em caso de empate, ordena pela data/hora mais distante da atual (to_char)
            const dateA = new Date(a.to_char);
            const dateB = new Date(b.to_char);

            // Ordena em ordem decrescente de data
            return dateB - dateA;
          });

          // Após ordenar, você pode continuar com a lógica de filtro e mapeamento
          this.state.callqueue
            .filter((queue) => {
              const callbackMidias = InfoUsers.callback_midias
                ? InfoUsers.callback_midias.split(",").map((m) => m.trim())
                : [];

              return (
                callbackMidias.length === 0 ||
                callbackMidias.includes(queue.mediaid.toString())
              );
            })
            .map((queue) => {
              if (
                parseInt(queue.callback_count) <
                  parseInt(InfoUsers.qtdecallback) &&
                parseInt(queue.status) === 0 &&
                checkCallBack === false
              ) {
                clearInterval(statusIntervalCBack);
                checkCallBack = true;
                checkCallBackAuto(
                  queue.queueid,
                  InfoUsers.tmcallback,
                  InfoUsers.qtdecallback,
                  queue
                );
              }
            });

          // this.state.callqueue.map((queue) => {
          //   if (
          //     parseInt(queue.callback_count) <
          //       parseInt(InfoUsers.qtdecallback) &&
          //     parseInt(queue.status) === 0 &&
          //     checkCallBack === false
          //   ) {
          //     clearInterval(statusIntervalCBack);
          //     checkCallBack = true;
          //     checkCallBackAuto(
          //       queue.queueid,
          //       InfoUsers.tmcallback,
          //       InfoUsers.qtdecallback,
          //       queue
          //     );
          //   }
          // });
        }
      } else if (
        StatusAgent.status === "Atendimento" ||
        StatusAgent.status === "Ligação" ||
        StatusAgent.status === "Discando" ||
        StatusAgent.status === "Chamando" ||
        StatusAgent.status === "Aftercallwork"
      ) {
        clearInterval(statusIntervalCBack);
        checkCallBack = false;
      }
    }

    const listSubservice = this.state.subservicesList || [];

    this.state.subservicesList = _.filter(listSubservice, (subservice) => {
      let arraySubservice = [subservice.title];
      return !_.isEmpty(this.state.textSearchSubservice)
        ? arraySubservice
            .toString()
            .toLowerCase()
            .indexOf(this.state.textSearchSubservice.toString().toLowerCase()) >
            -1
        : true;
    });
    this.state.callqueue = this.state.callqueue.filter((cliente) => {
      let date1 = Moment(this.state.initialDateAfter).format("YYYYMMDD");
      let date2 = Moment(this.state.finalDateAfter).format("YYYYMMDD");
      let date3 = Moment(cliente.to_char, "DD/MM/YYYY HH:mm:ss").format(
        "YYYYMMDD"
      );
      return date3 >= date1 && date3 <= date2;
    });

    this.state.qtdOfClientsInTheQueue = this.state.callqueue.length;

    this.state.callqueue = this.state.callqueue.slice(0, this.state.scrollEnd);

    // if (listCallQueue.length === 0) {
    //   this.state.subservicesList = [];
    // }

    // if (
    //   filterstatusstorage.length === this.state.typestatus.length &&
    //   document.getElementById(`checkbox-status-all`)
    // ) {
    //   this.state.textStatusCheck = "Desmarcar todos";
    //   document.getElementById(`checkbox-status-all`).checked = true;
    // }
    // if (
    //   filtermediastorage.length === this.state.midias.length &&
    //   document.getElementById(`checkbox-media-all`)
    // ) {
    //   this.state.textMediaCheck = "Desmarcar todos";
    //   document.getElementById(`checkbox-media-all`).checked = true;
    // }
    // if (
    //   filtersubservicestorage.length === this.state.subservicesList.length &&
    //   document.getElementById(`checkbox-subservice-all`)
    // ) {
    //   this.state.textSubserviceCheck = "Desmarcar todos";
    //   document.getElementById(`checkbox-subservice-all`).checked = true;
    // }

    if (AtdSimult.length > 0) {
      const filterAtd = AtdSimult.filter(
        (atd) => atd.idatendimento !== ContactId.idatendimento
      );
      const sumTotal = filterAtd.map(
        (atd) => (totalMsgsChats = totalMsgsChats + parseInt(atd.qtdmessage))
      );
      this.state.qtdOfChatsInTheQueue = AtdSimult.length;
    }

    if (!this.props.InfoUsers.standby_permission) {
      const verifyTab = localStorage.getItem("tabChoice");
      if (verifyTab === "waitingInfo") {
        localStorage.setItem("tabChoice", "nextCall");
        this.props.actionChangeNextCallQueueTab(true);
        this.props.actionChangeWaitingCallQueueTab(false);
        this.props.actionChangeChatCallQueueTab(false);
        this.setState({
          tabWaitingInfo: {
            ...this.state.tabWaitingInfo,
            isActive: false,
          },
          tabNextCallInfo: {
            ...this.state.tabNextCallInfo,
            isActive: true,
          },
          tabChatsInfo: {
            ...this.state.tabChatsInfo,
            isActive: false,
          },
        });
      }
    }

    //voltar aqui
    this.props.sendValuesQueueStandby(
      this.state.qtdOfClientsInTheQueue,
      this.state.qtdOfClientsInQuarentineZone,
      this.state.qtdOfUnreadedMessagesInQuarentineZone
    );

    return (
      <div
        id="column1"
        className={
          "chat-page queue-new small-column--margin-right" +
          this.state.visible +
          (InfoDisplay.infodisplay === "Clientes"
            ? " new-queueinew-side-menu new-queueinew-side-menu-v2"
            : " new-queueinew-side-menu new-queueinew-side-menu-v2 no-margin-and-no-round-border")
        }
      >
        <div
          className={
            "block full-height w-100 no-margin-bottom" +
            (InfoDisplay.infodisplay === "Clientes"
              ? " new-queueinew-side-menu new-queueinew-side-menu-v2"
              : " new-queueinew-side-menu new-queueinew-side-menu-v2 no-margin-and-no-round-border")
          }
          id="proximos-atendimentos"
        >
          <div
            className={
              "column-model__header" +
              (InfoDisplay.infodisplay === "Clientes"
                ? " new-queueinew-side-menu new-queueinew-side-menu-v2"
                : " new-queueinew-side-menu new-queueinew-side-menu-v2 no-margin-and-no-round-border")
            }
          >
            {!exhibDrawer && (
              <div
                className={
                  "column-model__header__title" +
                  (InfoDisplay.infodisplay === "Clientes"
                    ? " new-queueinew-side-menu new-queueinew-side-menu-v2 client-screen-header"
                    : " new-queueinew-side-menu new-queueinew-side-menu-v2 no-margin-and-no-round-border")
                }
              >
                <button
                  type="submit"
                  onClick={(event) => this.ShowVisible(false)}
                  className="column-model__header__title__btn tippy-default"
                  data-tippy-content="Ocultar"
                >
                  <Arrow />
                  {/* aq esta */}
                </button>
                {/* InfoDisplay.infodisplay === "Clientes" && ( */}
                <div className="queue-new-v2-menu-tabs">
                  {/* {InfoDisplay.infodisplay === "Clientes" && ( */}
                  <QueueTab
                    tabInfo={this.state.tabChatsInfo}
                    qtdClients={AtdSimult.length}
                    qtdMessages={totalMsgsChats}
                    onClick={() => {
                      const isAlreadyActive = this.state.tabChatsInfo.isActive;
                      if (isAlreadyActive) return;
                      this.props.actionChangeNextCallQueueTab(false);
                      this.props.actionChangeWaitingCallQueueTab(false);
                      this.props.actionChangeChatCallQueueTab(true);
                      this.setState({
                        tabWaitingInfo: {
                          ...this.state.tabWaitingInfo,
                          isActive: false,
                        },
                        tabNextCallInfo: {
                          ...this.state.tabNextCallInfo,
                          isActive: false,
                        },
                        tabChatsInfo: {
                          ...this.state.tabChatsInfo,
                          isActive: true,
                        },
                      });
                      localStorage.setItem("tabChoice", "chatInfo");
                    }}
                    iconUse={true}
                  />
                  {/* )} */}
                  <QueueTab
                    tabInfo={this.state.tabNextCallInfo}
                    qtdClients={this.state.qtdOfClientsInTheQueue}
                    onClick={() => {
                      const isAlreadyActive =
                        this.state.tabNextCallInfo.isActive;
                      if (isAlreadyActive) return;
                      this.props.actionChangeNextCallQueueTab(true);
                      this.props.actionChangeWaitingCallQueueTab(false);
                      this.props.actionChangeChatCallQueueTab(false);
                      this.setState({
                        tabWaitingInfo: {
                          ...this.state.tabWaitingInfo,
                          isActive: false,
                        },
                        tabNextCallInfo: {
                          ...this.state.tabNextCallInfo,
                          isActive: true,
                        },
                        tabChatsInfo: {
                          ...this.state.tabChatsInfo,
                          isActive: false,
                        },
                      });
                      localStorage.setItem("tabChoice", "nextCall");
                    }}
                    iconUse={true}
                  />
                  {this.props.InfoUsers.standby_permission && (
                    <QueueTab
                      tabInfo={this.state.tabWaitingInfo}
                      qtdClients={this.state.qtdOfClientsInQuarentineZone}
                      qtdMessages={
                        this.state.qtdOfUnreadedMessagesInQuarentineZone
                      }
                      onClick={() => {
                        const isAlreadyActive =
                          this.state.tabWaitingInfo.isActive;
                        if (isAlreadyActive) return;
                        this.props.actionChangeNextCallQueueTab(false);
                        this.props.actionChangeWaitingCallQueueTab(true);
                        this.props.actionChangeChatCallQueueTab(false);
                        this.setState({
                          tabNextCallInfo: {
                            ...this.state.tabNextCallInfo,
                            isActive: false,
                          },
                          tabWaitingInfo: {
                            ...this.state.tabWaitingInfo,
                            isActive: true,
                          },
                          tabChatsInfo: {
                            ...this.state.tabChatsInfo,
                            isActive: false,
                          },
                        });
                        localStorage.setItem("tabChoice", "waitingInfo");
                      }}
                      iconUse={true}
                    />
                  )}
                </div>
                {/* // )} */}
              </div>
            )}

            <div className="full-search">
              <div className="full-search__header">
                <Typography.H4 color={"gray-180"} weight={500}>
                  {this.state.tabNextCallInfo.isActive
                    ? this.state.tabNextCallInfo.title
                    : this.state.tabWaitingInfo.isActive
                    ? this.state.tabWaitingInfo.title
                    : this.state.tabChatsInfo.title}
                </Typography.H4>
                {!this.state.tabChatsInfo.isActive && (
                  <div className="full-search__header--icons">
                    <Tooltippy content={this.state.RetractExpand}>
                      <div
                        className="top-bar queue-new-v2-top-bar"
                        onClick={this.DisplayDetails.bind(this)}
                      >
                        <a
                          href="{#}"
                          className=""
                          data-action={this.state.expandcollapse}
                          id="expand-all-user-info"
                        >
                          {/* <i className="material-icons">{this.state.unfold}</i> */}
                          <IconMaximize />
                          {/* <span className="queue-new-v2-top-bar__expand-text">
                      {this.state.RetractExpand}
                    </span> */}
                        </a>
                      </div>
                    </Tooltippy>
                    <FilterIconNew
                      className="filter-icon"
                      onClick={() =>
                        this.setState({
                          openDrawer: true,
                        })
                      }
                    />
                  </div>
                )}
              </div>
              <div className="full-search_container">
                <button type="submit" className="full-search__btn">
                  <Search />
                </button>
                <input
                  type="text"
                  name="client-search"
                  id="client-search"
                  onChange={(event) => this.changeQueue(event)}
                  placeholder="Pesquisar"
                  value={
                    isQuarentineZone
                      ? this.state.filterQuarentineQueue
                      : Array.isArray(this.state.filterQueue) &&
                        this.state.filterQueue.length === 0
                      ? ""
                      : this.state.filterQueue
                  }
                />
                {this.state.filterQuarentineQueue ||
                (Array.isArray(this.state.filterQueue) &&
                  this.state.filterQueue.length > 0) ? (
                  <CloseCircle
                    color="#757575"
                    onClick={(event) => this.clearChangeQueue("")}
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>

            {this.renderItemQueue(
              IPCurrent,
              InfoUsers,
              StatusAgent,
              AtdSimult,
              OutBandService,
              PermissionRouter,
              callpark,
              initialDate,
              finalDate
            )}
          </div>
        </div>

        {InfoDisplay.infodisplay !== "Clientes" ? (
          <>
            <ModalsDetails.NewAnotationModal />

            <ModalsDetails.NewMessageFavoriteModal />

            <ModalsDetails.NewFileShareModal />

            <ModalsDetails.InteractionsHistoricModal />
          </>
        ) : (
          <></>
        )}

        <DeleteCallModal
          deletecdrid={this.state.deletecdrid}
          deletequeueid={this.state.deletequeueid}
          mediaid={this.state.mediaid}
        />

        <input type="hidden" id="simulation_click" name="simulation_click" />
        {/* <div
          style={{
            position: "absolute",
            right: "-9999999999999999999999999px",
            top: 0,
          }}
        >
          <PDFExport
            ref={(component) => (this.pdfExportComponent = component)}
            paperSize="A4"
          >
            <PdfDocument
              history={this.state.history}
              cliente={this.state.cliente}
              datapdfinit={this.state.datapdfinit}
              datapdfend={this.state.datapdfend}
              numero={this.state.clientpdf}
            />
          </PDFExport>
        </div> */}

        {this.state.tabNextCallInfo.isActive ? (
          <Drawer
            className="queue"
            filterApply={true}
            isOpen={this.state.openDrawer}
            setCloseDrawer={this.setVisibleDrawer}
            bind={this}
            filtersActive={this.state.typequeue}
            cleanFilters={(e) => {
              this.clearAllFields();
              this.clearAllFields();
            }}
            title="Filtros de fila"
          >
            <div className="drawer__queue-date">
              <FieldContainer
                title="Data início"
                className="case-client-queue"
                htmlFor=""
              >
                <DatePicker.DateRange
                  selected={initialDate}
                  setDate={(event) => {
                    const newDate = event;
                    this.setState({ initialDate: newDate });
                  }}
                  selectRangeType="start"
                  endDate={finalDate}
                  maxDate={finalDate}
                  dateFormat={"dd/MM/yyyy"}
                  showYearPicker={false}
                />
              </FieldContainer>

              <FieldContainer
                title="Data fim"
                className="case-client-queue"
                htmlFor=""
              >
                <DatePicker.DateRange
                  selected={finalDate}
                  setDate={(event) => {
                    const newDate = event;
                    this.setState({ finalDate: newDate });
                  }}
                  selectRangeType="end"
                  startDate={initialDate}
                  minDate={initialDate}
                  dateFormat="dd/MM/yyyy"
                  isClearable={false}
                  showYearPicker={false}
                />
              </FieldContainer>
            </div>
            <div className="drawer__div__content-box queue">
              <span className="drawer__div__content-box__label">
                Status da Fila:
              </span>
              <div
                className={
                  this.state.isViewStatus
                    ? "select card--no-mg active"
                    : "select card--no-mg"
                }
              >
                <button
                  className="select__btn"
                  type="button"
                  id="mult-filter-inside"
                  onClick={() =>
                    this.setState({
                      isViewStatus: !this.state.isViewStatus,
                      isViewChannels: false,
                      isViewSubservices: false,
                    })
                  }
                >
                  Selecione...
                  <i className="select__icon material-icons">
                    keyboard_arrow_right
                  </i>
                </button>
                <div className="options options--advanced">
                  <div className="options--advanced__filter-box">
                    <div className="options--advanced__filter-box__content">
                      <div className="checkbox checkbox__list">
                        <div className="checkbox__list__title">
                          Status
                          <div className="checkbox-all">
                            <li className="checkbox__item-all">
                              <input
                                className="checkbox__list__input"
                                id={"checkbox-status-all"}
                                name={"checkbox-status-all"}
                                type="checkbox"
                                defaultChecked={
                                  filterstatusstorage.length ===
                                  statusQueue.length
                                }
                                onChange={(event) =>
                                  this.handleCheckAll(event, "status")
                                }
                              />
                              <label htmlFor={"checkbox-status-all"}>
                                {filterstatusstorage.length ===
                                statusQueue.length
                                  ? "Desmarcar todos"
                                  : "Marcar todos"}
                                {/* {this.state.textStatusCheck} */}
                              </label>
                            </li>
                          </div>
                        </div>
                        {statusQueue.map((status) => (
                          <li className="checkbox__item" key={status.id}>
                            <input
                              className="checkbox__list__input"
                              id={"checkbox-status-" + status.id}
                              name={"checkbox-status-" + status.id}
                              type="checkbox"
                              onChange={(event) =>
                                this.getFilterStatus(event, status.id)
                              }
                              defaultChecked={
                                this.state.typestatus.findIndex(function (val) {
                                  return parseInt(val) === parseInt(status.id);
                                }) !== -1
                                  ? true
                                  : false
                              }
                            />
                            <label htmlFor={"checkbox-status-" + status.id}>
                              {status.title}
                            </label>
                          </li>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="drawer__div__content-box queue">
              <span className="drawer__div__content-box__label">Canais:</span>
              <div
                className={
                  this.state.isViewChannels
                    ? "select card--no-mg active"
                    : "select card--no-mg"
                }
              >
                <button
                  className="select__btn"
                  type="button"
                  id="mult-filter-inside"
                  onClick={() =>
                    this.setState({
                      isViewChannels: !this.state.isViewChannels,
                      isViewStatus: false,
                      isViewSubservices: false,
                    })
                  }
                >
                  Selecione...
                  <i className="select__icon material-icons">
                    keyboard_arrow_right
                  </i>
                </button>
                <div className="options options--advanced">
                  <div className="options--advanced__filter-box">
                    <div className="options--advanced__filter-box__content">
                      <div className="checkbox checkbox__list">
                        <div className="checkbox__list__title">
                          Canais
                          <div className="checkbox-all">
                            <li className="checkbox__item-all">
                              <input
                                className="checkbox__list__input"
                                id={"checkbox-media-all"}
                                name={"checkbox-media-all"}
                                type="checkbox"
                                checked={
                                  filtermediastorage.length ===
                                  this.state.midias.length
                                }
                                onChange={(event) =>
                                  this.handleCheckAll(event, "media")
                                }
                              />
                              <label htmlFor={"checkbox-media-all"}>
                                {filtermediastorage.length ===
                                this.state.midias.length
                                  ? "Desmarcar todos"
                                  : "Marcar todos"}
                                {/* {this.state.textMediaCheck} */}
                              </label>
                            </li>
                          </div>
                        </div>
                        {this.state.midias.map((midia) => (
                          <li className="checkbox__item" key={midia.id}>
                            <input
                              className="checkbox__list__input"
                              id={"checkbox-media-" + midia.id}
                              name={"checkbox-media-" + midia.id}
                              type="checkbox"
                              defaultChecked={
                                this.state.typemedia.findIndex(function (val) {
                                  return val === midia.id;
                                }) !== -1
                                  ? true
                                  : false
                              }
                              onChange={(event) =>
                                this.getFilterMedia(event, midia.id)
                              }
                            />
                            <label htmlFor={"checkbox-media-" + midia.id}>
                              {midia.describer}
                            </label>
                          </li>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="drawer__div__content-box queue">
              <span className="drawer__div__content-box__label">
                Subserviços:
              </span>
              <div
                className={
                  this.state.isViewSubservices
                    ? "select card--no-mg active"
                    : "select card--no-mg"
                }
              >
                <button
                  className="select__btn"
                  type="button"
                  id="mult-filter-inside"
                  onClick={() =>
                    this.setState({
                      isViewSubservices: !this.state.isViewSubservices,
                      isViewChannels: false,
                      isViewStatus: false,
                    })
                  }
                >
                  Selecione...
                  <i className="select__icon material-icons">
                    keyboard_arrow_right
                  </i>
                </button>
                <div className="options options--advanced">
                  <div className="options--advanced__search-box">
                    <div className="full-search queue">
                      <input
                        type="text"
                        name="client-search"
                        id="client-search"
                        placeholder="Busca..."
                        onChange={(event) =>
                          this.setState({
                            textSearchSubservice: event.target.value,
                          })
                        }
                      />
                      <button type="submit" className="full-search__btn">
                        <i className="material-icons">search</i>
                      </button>
                    </div>
                  </div>
                  <div className="options--advanced__filter-box">
                    <div className="options--advanced__filter-box__content">
                      <div className="checkbox checkbox__list">
                        <div className="checkbox__list__title">
                          Subserviços
                          <div className="checkbox-all">
                            <li className="checkbox__item-all">
                              <input
                                className="checkbox__list__input"
                                id={"checkbox-subservice-all"}
                                name={"checkbox-subservice-all"}
                                type="checkbox"
                                checked={
                                  filtersubservicestorage.length ===
                                  this.state.subservicesList.length
                                }
                                onChange={(event) =>
                                  this.handleCheckAll(event, "subservice")
                                }
                              />
                              <label htmlFor={"checkbox-subservice-all"}>
                                {filtersubservicestorage.length ===
                                this.state.subservicesList.length
                                  ? "Desmarcar todos"
                                  : "Marcar todos"}
                                {/* {this.state.textSubserviceCheck} */}
                              </label>
                            </li>
                          </div>
                        </div>
                        {this.state.subservicesList.map((subservice) => (
                          <li className="checkbox__item" key={subservice.id}>
                            <input
                              className="checkbox__list__input"
                              id={"checkbox-subservice-" + subservice.id}
                              name={"checkbox-subservice-" + subservice.id}
                              type="checkbox"
                              defaultChecked={
                                this.state.typesubservice.findIndex(function (
                                  val
                                ) {
                                  return val === subservice.id;
                                }) !== -1
                                  ? true
                                  : false
                              }
                              onChange={(event) =>
                                this.getFilterSubservice(event, subservice.id)
                              }
                            />
                            <label
                              htmlFor={"checkbox-subservice-" + subservice.id}
                            >
                              <span title={subservice.title}>
                                {subservice.title}
                              </span>
                            </label>
                          </li>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Drawer>
        ) : (
          <Drawer
            className="queue"
            filterApply={true}
            isOpen={this.state.openDrawer}
            setCloseDrawer={this.setVisibleDrawer}
            bind={this}
            filtersActive={this.state.typequeue}
            cleanFilters={(e) => {
              this.clearclearAllFieldsQuarentine();
              this.clearclearAllFieldsQuarentine();
            }}
            title="Filtros do Standby"
          >
            <div className="drawer__queue-date">
              <FieldContainer
                title="Data início"
                className="case-client-queue"
                htmlFor=""
              >
                <DatePicker.DateRange
                  selected={this.state.initialDateQuarentine}
                  setDate={(event) => {
                    const newDate = event;
                    this.props.actionEditInitialDateFilterQuarentine(newDate);
                    this.setState({ initialDateQuarentine: newDate });
                  }}
                  selectRangeType="start"
                  endDate={this.state.finalDateQuarentine}
                  maxDate={this.state.finalDateQuarentine}
                  dateFormat={"dd/MM/yyyy"}
                  showYearPicker={false}
                />
              </FieldContainer>

              <FieldContainer
                title="Data fim"
                className="case-client-queue"
                htmlFor=""
              >
                <DatePicker.DateRange
                  selected={this.state.finalDateQuarentine}
                  setDate={(event) => {
                    const newDate = event;
                    this.props.actionEditFinalDateFilterQuarentine(newDate);
                    this.setState({ finalDateQuarentine: newDate });
                  }}
                  selectRangeType="end"
                  startDate={this.state.initialDateQuarentine}
                  minDate={this.state.initialDateQuarentine}
                  dateFormat="dd/MM/yyyy"
                  isClearable={false}
                  showYearPicker={false}
                />
              </FieldContainer>
            </div>
            <div className="drawer__div__content-box queue">
              <span className="drawer__div__content-box__label">Canais:</span>
              <div
                className={
                  this.state.isViewChannels
                    ? "select card--no-mg active"
                    : "select card--no-mg"
                }
              >
                <button
                  className="select__btn"
                  type="button"
                  id="mult-filter-inside"
                  onClick={() =>
                    this.setState({
                      isViewChannels: !this.state.isViewChannels,
                      isViewStatus: false,
                      isViewSubservices: false,
                    })
                  }
                >
                  Selecione...
                  <i className="select__icon material-icons">
                    keyboard_arrow_right
                  </i>
                </button>
                <div className="options options--advanced">
                  <div className="options--advanced__filter-box">
                    <div className="options--advanced__filter-box__content">
                      <div className="checkbox checkbox__list">
                        <div className="checkbox__list__title">
                          Canais
                          <div className="checkbox-all">
                            <li className="checkbox__item-all">
                              <input
                                className="checkbox__list__input"
                                id={"checkbox-media-all-quarentine"}
                                name={"checkbox-media-all-quarentine"}
                                type="checkbox"
                                checked={
                                  this.state.filtermediastorageQuarentine
                                    .length === this.state.midias.length
                                }
                                onChange={(event) =>
                                  this.handleCheckAllQuarentine(event, "media")
                                }
                              />
                              <label htmlFor={"checkbox-media-all-quarentine"}>
                                {this.state.filtermediastorageQuarentine
                                  .length === this.state.midias.length
                                  ? "Desmarcar todos"
                                  : "Marcar todos"}
                                {/* {this.state.textMediaCheck} */}
                              </label>
                            </li>
                          </div>
                        </div>
                        {this.state.midias.map((midia) => (
                          <li className="checkbox__item" key={midia.id}>
                            <input
                              className="checkbox__list__input"
                              id={"checkbox-media-quarentine-" + midia.id}
                              name={"checkbox-media-quarentine-" + midia.id}
                              type="checkbox"
                              defaultChecked={
                                this.state.filtermediastorageQuarentine.findIndex(
                                  function (val) {
                                    return val === midia.id;
                                  }
                                ) !== -1
                                  ? true
                                  : false
                              }
                              onChange={(event) =>
                                this.getFilterMediaQuarentine(event, midia.id)
                              }
                            />
                            <label
                              htmlFor={"checkbox-media-quarentine-" + midia.id}
                            >
                              {midia.describer}
                            </label>
                          </li>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Drawer>
        )}

        {!this.state.tabChatsInfo.isActive && (
          <TransferClientModal
            ClosePopovers={(event) => this.ClosePopovers()}
            atdCurso={this.state.atdCurso}
            infoQueue={{
              cdrid: this.state.cdrid,
              scriptid: this.state.scriptid,
              mediaid: this.state.mediaid,
              queueId: this.state.queueId,
            }}
          />
        )}
      </div>
    );
  }
  exportPDFWithMethod = () => {
    savePDF(ReactDOM.findDOMNode(this.pdfExportComponent), {
      paperSize: "A4",
      margin: 10,
      fileName: this.state.cliente + "_" + this.state.clientpdf + ".pdf",
    });
  };
  exportPDFWithComponent = () => {
    this.pdfExportComponent.save();
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(QueueNew);
